{
    "COMMON": {
        "ADD": "Add",
        "APPLY": "Apply",
        "ACCESS": "Access",
        "CLOSE": "Close",
        "ALL": "All",
        "MORE": "Learn more",
        "CANCEL": "Cancel",
        "DELETE": "Delete",
        "NONE": "None",
        "CONFIRM": "Confirm",
        "CALL": "Call",
        "EDIT": "Modify",
        "COPY": "Copy",
        "RESET": "Reset",
        "RESTORE": "Restore",
        "SAVE": "Save",
        "SEARCH_BUTTON": "Search",
        "NEED_UPDATE": "An update is available",
        "INSTALLATION_FAILED": "Application update failed",
        "NEED_REFRESH": "Application needs to refresh",
        "NO_DATA_MESSAGE": "No data found",
        "NO_RESULT": "No result",
        "BANNER": "Co-assist's customer support and sales department during this period of isolation remain open from <b>9am to 6pm</b> and are also <b>exceptionally open on Saturdays and Sundays.</b>",
        "INVALID_FORM": "The form is not valid",
        "YOUTUBE": "Go to Youtube",
        "NEW": "New releases",
        "NOTIFICATION_SOUND": {
            "ON": "Enable notification sound",
            "OFF": "Disable notification sound",
            "TOGGLE_NOTIFICTION_SOUND": "Toggle notification sound : ",
            "CHOOSE_NOTIFICTION_SOUND": "Choose notification sound : ",
            "SOUND_ONE": "Sound one",
            "SOUND_TWO": "Sound two",
            "SOUND_THREE": "Sound three",
            "MODIFY_NOTIFICATION_SOUND": "Modify notification sound",
            "CHOOSE_NOTIFICATION_SOUND": "Choose notification sound",
            "PLAY_SOUND": "Play Sound"
        },
        "HELPER": "Helper",
        "ADVANCED_MODE": "Advanced mode",
        "CONNECTED": "Connected since {{date}}",
        "DISCONNECTED": "Disconnectedsince {{date}}",
        "LOADING": {
            "GENERIC": "Loading ...",
            "HUB_SERVICE": "Loading {{service}} ...",
            "ASSIGNEMENT": "Assignment in progress ...",
            "APPLY_PARAMETERS": "Parameters assignement in progress ..."
        },
        "SELECTOR": {
            "DAILY": "Day",
            "MONTHLY": "Month"
        },
        "TOAST": {
            "ERROR_TITLE": "Sorry!",
            "INTERNET_LOST": "No internet link",
            "INTERNET_RENEW": "Internet linked",
            "ERROR_OCCURED": "An error has occurred",
            "ERROR_API_TEXT": "Communication with server failed",
            "ACCESS_DENIED": "Access denied",
            "API_REQUEST_EXCEEDED": "Too many requests or rate exceeded. Retry or contact support.",
            "SERIVCE_UNVAILABLE": "Service unvailable for the moment",
            "CONTINUE": "You can continue your subscription",
            "NO_ACTION": "Impossible to display for now",
            "SUCCESS_TITLE": "Success!",
            "REQUEST_SENT": "Your request has been sent",
            "DATA_NOT_AVAILABLE": "The file isn't available yet",
            "CUSTOMER_SERVICE": "Customer service has been notified of your request",
            "ADDRESS_NOT_FOUND": "The address entered cannot be found",
            "TOO_MUCH_DATA": "Too much data",
            "ASK_CUSTOMER_SERVICE": "Please ask to customer service:contact@co-assist.fr",
            "ALERT_HANDLED": "The alert has been handled",
            "ALERT_ACQUITTED": "The alert has been acquitted",
            "ALERT_UPDATED": "The alert has been updated",
            "SYNC_CAW": "Please put the watch on the charging pad to synchronise it.",
            "ADVANCED_MODE_ON": "Advanced mode has been enable for 15 minutes",
            "ADVANCED_MODE_OFF": "Advanced mode has been disable",
            "ADD_USER_SUCCESS": "User has been added",
            "UPDATE_USER_SUCCESS": "User has been updated",
            "DELETE_USER_SUCCESS": "User has been deleted",
            "COPY_CLIPBOARD": "Text copied successfully!",
            "CLIPBOARD_COPY_NOT_SUPPORTED": "Copy to clipboard not supported",
            "PROFILE_HAS_BEEN_CREATED": "Alert profile has been created",
            "PROFILE_HAS_BEEN_RENAMED": "Alert profile has been renamed",
            "PROFILE_HAS_BEEN_DELETED": "Alert profile has been deleted"
        },
        "TOOLTIP": {
            "EDIT_PROFILE_NAME": "Double click to rename, right click to delete"
        },
        "USER_INFO": {
            "ADDRESS": "Address",
            "EMAIL": "Email",
            "EMAIL_HINT": "An email is mandatory to connect to Co-assist applications",
            "NAME": "Name",
            "FIRST_NAME": "First name",
            "LAST_NAME": "Last Name",
            "PAYEE": "Payee",
            "PHONE_NUMBER": "Phone number",
            "PROM_ID": "Telecare ID",
            "ADDITIONAL_INFORMATION": "Additional informations",
            "DISPLAY_HINT": "The information in this field is added to the name to further identify the user. Example: Jacques Martin apartment 28.",
            "USER_ID": "User ID",
            "LOGIN_ID": "Login ID",
            "DEFAULT_LANGUAGE": "Default language for alert services",
            "IVR_EXTENSION": "IVR Extension number",
            "PBX_EXTENSION": "SIP extension (To)",
            "POST_NUMBER": "extension no. {{ivrExtension}}",
            "SEND_ON_STATUS": "Entry transmitted during:",
            "RECOVER_PASSWORD": "Please enter a valid address and validate the user card before you can reset the password.",
            "SELECT_HELPER": "Select an helper",
            "NO_HELPERS_AVAILABLE_WA": "No helpers are linked to a WhatsApp account.",
            "NO_HELPERS_AVAILABLE_PHONE_NUMBER": "No helpers are linked to a phone number.",
            "NO_HELPERS_AVAILABLE_EMAIL": "No helpers are linked to an email address.",
            "STATE_NOTIFICATION": {
                "start": "Start",
                "notifying": "Notification",
                "handle": "Handled",
                "acquitted": "Acquitted",
                "interrupted": "Closure - Interrupted",
                "expired": "Closure - Expired",
                "solved": "Closure",
                "OTHER": "other"
            },
            "WHATSAPP": {
                "CHECKBOX": "Link a WhatsApp Account",
                "NUMBER_LINKED": "WhatsApp number linked",
                "SEND_CODE": "Send Send registration request",
                "ENTER_CODE": "Enter the verification code received",
                "CODE_NOT_RECEIVED": "The code is sent to your WhatsApp App",
                "VERIFIED": "WhatsApp vérified",
                "LINK": "Link",
                "INCORRECT_CODE": "Incorrect code",
                "UNLINK": "Unlink my WhatsApp number"
            },
            "WEBHOOK": {
                "method": "Method",
                "url": "URL",
                "ADD_HEADER": "Add a header",
                "headers": "Headers",
                "key": "Key",
                "value": "Value",
                "customBody": "Custom body",
                "availableVariables": "Available variables : ",
                "NO_CUSTOM_BODY": "Standard",
                "CUSTOM_BODY": "Custom",
                "URL_PREVIEW": "URL Preview : ",
                "BODY_PREVIEW": "Body Preview : ",
                "URL_QUERY_ERROR": "Your custom body values cannot be empty or contain the % character.",
                "URL_KEY": "Your entry : ",
                "URL_VALUE": "Choose or define a variable : ",
                "STATE_SPECIFIC_BODIES": "State-specific custom bodies : ",
                "ADD_STATE_BODY": "Add custom state body",
                "CUSTOM_BODY_FOR_STATE": "Custom state bodies",
                "TEST_WEBHOOK": "Test webhook",
                "TEST_WEBHOOK_DIALOG_TITLE": "Test webhook",
                "TEST_WEBHOOK_SEND": "Send",
                "TEST_ALERT_STATUS": "Alert status",
                "TEST_ALERT_TYPE": "Alert type",
                "TEST_MODULE_ID": "Module identifier",
                "TEST_ALERT_ID": "Alert identifier",
                "TEST_DISPLAY_NAME": "User (displayName)",
                "TEST_NAME": "Name (name)",
                "TEST_ADDITIONAL_INFO": "Additional information",
                "TEST_LAST_KNOWN_ADDRESS": "Last known address",
                "TEST_LAST_KNOWN_POSITION": "Last known position",
                "TEST_POSITION_FORMAT_ERROR": "Expected format: lat, lng (e.g. 48.8698, 2.3078)",
                "TEST_REGENERATE": "Regenerate",
                "TEST_SUCCESS": "Request sent successfully"
            },
            "ESPA": {
                "header": "Header",
                "pagerNumber": "Call address",
                "displayMessage": "Display message",
                "beepCoding": "Beep coding",
                "callType": "Call type",
                "numberOfTransmissions": "Number of transmissions",
                "priority": "Priority",
                "targetHost": "Target IP",
                "targetPort": "Port",
                "transportType": "Transport type",
                "includeBcc": "Append the BCC checksum to the frame",
                "availableVariables": "Available variables : ",
                "framePreview": "ESPA frame preview : ",
                "rawFrame": "Raw frame (escaped) : ",
                "TEST": {
                    "BUTTON": "Test",
                    "SUCCESS": "Test frame sent",
                    "ERROR": "Failed to send the test frame"
                },
                "CALL_TYPES": {
                    "RESET": "Reset",
                    "SPEECH": "Speech",
                    "STANDARD": "Standard"
                },
                "PRIORITIES": {
                    "ALARM": "Alarm",
                    "HIGH": "High",
                    "NORMAL": "Normal"
                }
            }
        },
        "MODULE_INFO": {
            "MODULEID": "moduleID"
        },
        "DAYS": {
            "MONDAY": "Monday",
            "TUESDAY": "Tuesday",
            "WEDNESDAY": "Wednesday",
            "THURSDAY": "Thursday",
            "FRIDAY": "Friday",
            "SATURDAY": "Saturday",
            "SUNDAY": "Sunday"
        },
        "CIVILITY": "Civility",
        "MALE": "Mister",
        "FEMALE": "Madam",
        "NOT_DEFINED": "Not defined",
        "INFORMATION": "Information",
        "YES": "Yes",
        "NO": "No",
        "USER_NAME_PLACEHOLDER": "Username",
        "BACK": "Back",
        "CONTINUE": "Continue",
        "LATER": "Choose later",
        "SEND": "Send",
        "GO_TO_LOGIN": "Return to login",
        "UTC": "UTC",
        "ASK_TO_BE_CALLED": "Request to be called by our advisers",
        "BE_CALLED": "Be called back",
        "ADVISOR_NOTIFIED": "An advisor has been notified",
        "RECOMMENDATION": "Would you like to improve coverage in the user's home?",
        "FREE": "Free",
        "TIME": {
            "HOURS": "Hours",
            "MINUTES": "Minutes",
            "SECOND": "second"
        },
        "DISABLED_FUNCTIONNALITY": "Available with a higher plan. Contact support team to learn more."
    },
    "ERROR": {
        "404": {
            "TITLE": "Oops! 404 error",
            "BODY": "The page you are looking for cannot be found"
        }
    },
    "VALIDATION": {
        "REQUIRED": "Required",
        "PICK_CHOICE": "Pick your choice",
        "EMAIL": "Email",
        "PHONE_NUMBER": "Phone number",
        "VERIFY_METHOD": "How would you like to activate your account?",
        "VERIFY_TITLE": "Account activation of",
        "INVALID_FIELD": "Invalid field",
        "WRONG_USERID": "Invalid account",
        "WRONG_EMAIL": "This email does not match the following user:",
        "WRONG_TEL": "This phone number does not match the following user:",
        "NON_EXISTENT_USER": "Non existent user",
        "ENTER_CODE": "Wrong verification token.",
        "VALIDATION_CODE_ERROR": "Invalid verification code",
        "VALIDATE_SUCCESS": "Your account has been validated",
        "EMAIL_VALIDATION_DONE": "A validation email was sent",
        "OVERLAPS": "Time ranges cannot be overlapped",
        "INVALID_TIME_RANGE": "The start time cannot be later than the end time",
        "INVALID_JSON_FORMAT": "The format of the inputted code is invalid.",
        "UNKNOWN_HELPERS": "The helper(s) configured for '{{endpoint}}' could not be found",
        "UNKNOWN_PHONE_NUMBERS": "The phone number(s) configured for '{{endpoint}}' have no associated helper(s)",
        "UNKNOWN_EMAILS": "The email(s) configured for '{{endpoint}}' have no associated helper(s)",
        "HELPER_MISSING_ENDPOINT": "No contact information for the helper(s) configured for '{{endpoint}}'"
    },
    "GROUP_ASSOCIATIONS": {
        "DELETE": "Delete the user, all their data and dissociate its equipments",
        "BATTERY_LVL": "Battery level: {{value}}%",
        "TOAST": {
            "ASSIGN": {
                "SUCCESSFUL_ASSIGNMENT": "Successfully associated equipment",
                "SUCCESSFUL_UNASSIGNMENT": "Successfully dissociated equipment"
            }
        },
        "HELPED_ASSOCIATIONS": {
            "DIALOG": {
                "TITLE": "Watch list",
                "CHOOSE_EXISTING": "Associate with an existing equipment",
                "VIRGIN_CONFIGURATION": "No alert will be activated",
                "CHOOSE_CONFIGURATION": "Choice of device alert configuration",
                "COPY_GROUP_CONFIGURATION": "Entity",
                "COPY_USER_CONFIGURATION": "User",
                "COPY_PROFILE": "Alert profile '{{name}}'",
                "COPY_NONE_CONFIGURATION": "Virgin",
                "CONFIRM_DIALOG_TITLE": "Dissociation of the equipment {{moduleID}}",
                "CONFIRM_DIALOG_TEXT": "Are you sure you want to dissociate the equipment from this user?",
                "DELETE_HELPED_TITLE": "Removal of a user",
                "DELETE_HELPED": "Are you sure you want to delete: {{name}}?",
                "DELETE_HELPED_WITH_MODULE": "Are you sure you want to delete: {{name}}? The attached equipments will also be disassociated."
            },
            "TITLE": "Users",
            "ADD_HELPED": "Add a user",
            "UPDATE_HELPED": "Update a user",
            "DIALOG_INFO": "List of the users for whom I would like to be informed in the event of an alert.<br>Caution, if a user has neither a watch nor a Compagnon app, no alert can be launched.",
            "NO_MODULE": "No associated equipment",
            "MODULE_IDENTITY": "{{device}} : {{moduleID}}",
            "MODULE_NAME": "{{device}} « {{name}} »: {{moduleID}}",
            "ASSOCIATE": "Assign an equipment to a user",
            "DISASSOCIATE": "Cancel the assignment of the equipment to the user and keep the user"
        },
        "MODULE_ASSOCIATIONS": {
            "DIALOG": {
                "TITLE": "User list",
                "SELECT_PLACEHOLDER": "Associate with an user",
                "NO_HELPEDS": "No user available"
            },
            "TITLE_CAW": "Watches",
            "TITLE_CAB": "Bracelets",
            "TITLE_BLEBeacon": "Location BLE Beacon",
            "TITLE_DS3604": "Display",
            "TITLE_AlertUnit": "Alert units",
            "TITLE_CALAlertUnit": "Alert units",
            "TITLE_BSSigfox": "Sigfox base stations",
            "TITLE_BSLora": "LoRa base stations",
            "TITLE_SimplePack4.0Magnetic": "Door opening detector",
            "TITLE_SimplePack4.0Button": "Medical alarms",
            "TITLE_I870SF": "Smoke detectors (public networks)",
            "TITLE_I870LR": "Smoke detectors (private networks)",
            "TITLE_ZEPRLR": "Smoke detectors",
            "TITLE_X865LSOrigin": "Smoke detectors",
            "TITLE_X855LSGuard": "Smoke detectors",
            "TITLE_X870LSOriginPlus": "Smoke detectors",
            "TITLE_X860LSGuardPlus": "Smoke detectors",
            "TITLE_ZEECDMINOLR": "Water meters",
            "TITLE_LHT65NLR": "Temperature sensor",
            "TITLE_GH5200": "Badge mobile GPS",
            "TITLE_EV07B": "Button mobile GPS",
            "TITLE_EV07BChargeBase": "EV07B Charge Base",
            "TITLE_EV04": "Button mobile GPS",
            "TITLE_EV04ChargeBase": "EV04 Charge Base",
            "TITLE_EV05": "Montre GPS",
            "TITLE_EV05ChargeBase": "EV05 Charge Base",
            "TITLE_SmartDati": "SmartDati",
            "TITLE_TMT250": "Button mobile GPS",
            "TITLE_ARF8170BCA": "Dry Contact",
            "TITLE_ARF8171BA": "Dry Contact",
            "TITLE_CALDS": "Door opening detector",
            "TITLE_CALBeacon": "Beacon",
            "TITLE_CALDryContact": "Dry Contact",
            "TITLE_Luna4G": "Luna Station",
            "TITLE_TAGID": "Tag",
            "TITLE_CALToggle": "Pull cords",
            "TITLE_CALPear": "Bed panic button",
            "TITLE_CALWornBracelet": "Mobile panic button",
            "TITLE_CALSimpleButton": "Simple button",
            "TITLE_NetworkDevice": "Network device",
            "TITLE_LDS02DS": "Door opening detector",
            "TITLE_LDS02SimpleButton": "Simple button",
            "TITLE_VH2BBUS01": "Radar",
            "TITLE_WSM02": "Bed occupancy sensor",
            "TITLE_Tunstall": "Tunstall",
            "NO_MODULE_FOUND": "No equipment available",
            "DIALOG_INFO": "List of equipment I own. I can associate an equipment with any user from the user list.",
            "ASSOCIATED_WITH": "Associated with {{name}}",
            "NOT_ASSOCIATED": "Not associated",
            "ASSOCIATE": "Assign a user to an equipment",
            "DISASSOCIATE": "Delete the user's assignment to the equipment"
        }
    },
    "ADMINISTRATION": {
        "BATTERY_TO_BE_CHARGED": {
            "TITLE": "Watches to be charged ({{number}})"
        },
        "DEVICE_TO_BE_SYNC": {
            "TITLE": "Watches to be synchronised ({{number}})",
            "NO_DEVICE_TO_SYNC": "All watches are synchronized"
        },
        "PARC_STATUS": {
            "TITLE": "Fleet state",
            "USED": "Associated devices",
            "NON_FUNCTIONAL": "of which functional equipment"
        },
        "NUMBER_OF_ALERTS": {
            "TITLE": "Viewing the week's alerts"
        },
        "ADMIN_USERS_DASHBOARD": {
            "TITLE": "User table",
            "DEVICE_TYPE_FILTER": "Displayed device types",
            "SELECT_TEXT": "All",
            "NO_DATA_MESSAGE": "No data found",
            "COLUMNS": {
                "MODULE_STATE": {
                    "TITLE": "Service state",
                    "SELECT": {
                        "OK_MODULE_STATE": "Service in working order",
                        "ISSUE_MODULE_STATE": "Last two routine messages not received",
                        "WARNING_MODULE_STATE": "Last routine message not received",
                        "UNKNOWN_MODULE_STATE": "No information"
                    }
                },
                "BATTERY_LEVEL": {
                    "TITLE": "Battery level"
                },
                "CONNECTIVITY": {
                    "TITLE": "Connectivity"
                },
                "IN_ALERT": {
                    "TITLE": "Open alert",
                    "SELECT": {
                        "NO_ALERT": "No alert",
                        "IN_ALERT": "In alert",
                        "BUTTON": "Button press alert",
                        "INACTIVITY": "Immobility detection",
                        "FALL": "Fall detection alert",
                        "ZONE_EXIT": "Zone exit alert ",
                        "LOW_BATTERY": "Low battery alert",
                        "CRITICAL_BATTERY": "Empty battery alert",
                        "SMOKE": "Smoke Detection Alert"
                    }
                },
                "EQUIPPED": {
                    "TITLE": "User equipped",
                    "SELECT": {
                        "USER_EQUIPPED": "User equipped",
                        "USER_NOT_EQUIPPED": "User not equipped"
                    }
                }
            }
        }
    },
    "PASSWORD_RESET": {
        "ERROR_TOAST": "Server communication failed or incorrect login",
        "EMAIL_ERROR": "This user has no email",
        "GO_BACK": "< Back",
        "RESET_PASSWORD": "Password reset",
        "CONFIRM_RESET_PASSWORD": "Do you really want to reset the password?",
        "MANDATORY_FIELD": "Mandatory field",
        "INCORRECT_LOGIN": "Incorrect password",
        "LOGIN_PLACEHOLDER": "Username",
        "SUCCESS_TEXT": "Request for a password reset sent.",
        "SUCCESS_TITLE": "Please follow instructions as specified in the email just sent.",
        "SUCCESS_GO_TO_LOGIN": "Go to the login page in {{second}} seconds.",
        "AUTO_REDIRECT_TO_LOGIN": "You will be redirected to the login page.",
        "ERROR_TO_SHORT": "Your pin should be 6 characters long",
        "NEW_PASSWORD_FOR": "New pin code for {{arg}}",
        "DIFFERENT_PASSWORD_NEEDED": "You can't use your former pin",
        "ALL_FIELDS_MANDATORY": "All fields mandatory",
        "PASSWORDS_DONT_MATCH": "Pin codes don't match",
        "NEW_PASSWORD_PLACEHOLDER": "New pin",
        "PASSWORD_CONFIRMATION_PLACEHOLDER": "Pin code confirmation",
        "RESET_SUCCESS": "Your password has been reset.",
        "REQUEST_CHANGE_PASSWORD": "Reset password",
        "WRONG_LINK_TITLE": "The link used to reset the password is incorrect",
        "WRONG_LINK_TEXT": "If you want to reset your password, click here",
        "OLD_LINK_TITLE": "The link used to reset the password has expired",
        "OLD_LINK_TEXT": "If you want to receive a new link, click here"
    },
    "EXIT_AREA": {
        "TITLE": "Configuration of the life area",
        "DIALOG_INFO": "If the \"location tracking\" feature is enabled, the location is sent every five minutes as soon as the watch is in movement. Otherwise, the location is only sent in the event of an alert.",
        "CIRCULAR_ZONE_BUTTON": "Circle area",
        "PATH_ZONE_BUTTON": "Polygon area",
        "ROOM": "Room",
        "ROOMSET": "Roomset",
        "ZONE_DELIMITATION": "Zone delimitation",
        "PLEASE_FILL_ADDRESS": "Please fill in the address corresponding to the center of the circle. Then define the radius.",
        "POLYGON_HELP": "The living area is the area in which the user can move without an alert being issued. To configure the zone exit alert, you must define a safe life zone for the user. You can define either a circle area or a polygon on the map. Click on the map to add a vertex.<br>Drag the vertex to move it.<br>Right click on the vertex to remove it.",
        "INOUT_ZONE_EXIT_HELP": "<p>The live zone is the zone in which the user can move without an alert being issued.</p> <p>You can choose between the radar coverage zone or the aggregation of the coverage zones of the radars associated with the user/room.</p>",
        "ROOM_EXPLANATION": "An alert is generated if the user has left the radar's coverage area",
        "ROOMSET_EXPLANATION": "An alert is created if the user has left the coverage area of all the devices associated with their account (for all devices with an active zone exit alert).",
        "CHANGED_APPLIED_TO_OTHERS": "The configuration of this radar will also be applied to {{moduleIDs}}.",
        "ROOMSET_LIST_MODULES": "The aggregated zone includes the following radars: {{moduleIDs}}",
        "RESTART_BUTTON": "Try again",
        "ADDRESS_ZONE_CENTER": "Address (circle center)",
        "SEARCH_BUTTON": "Center the map",
        "MAP_POSITIONING": "Map positioning",
        "MAP_POSITIONING_DESCRIPTION": "You can drag and drop to the desired position on the map, or write the address.",
        "MAP_ADDRESS_POSITIONING": "Map positioning through address input",
        "RADIUS_SIZE": "Distance (circle radius)",
        "TOAST": {
            "SUCCESS": "Area configuration done!",
            "POLY_ERROR": "Please set at least 3 points"
        },
        "CHOOSE_ZONE_TYPE": "You must choose the type of plot you want.",
        "START_CIRCULAR": "Click on the map to define the centre of the area or enter the address in the \"Address\" field.",
        "TIPS_CIRCULAR": "Hold the click on the centre of the area and drag to move it.",
        "START_POLYGON": "Click on the map to start plotting your area.",
        "TIPS_POLYGON": "Right click to delete a vertex, hold and drag to move it."
    },
    "MANAGE_ALERT_PROCESS": {
        "TITLE": "Manage the notification processes of {{name}}",
        "TITLE_GROUP": "Manage the notification processes of the entity",
        "TITLE_CONFIGURATION": "Configuration",
        "TITLE_ID": "Identification",
        "NO_DESCRIPTION": "No description",
        "CALL_ORDER": "Notification order of the helpers",
        "TITLE_ASK_HELPER_TO_MANAGE_ALERT_CALL": "Recall the helper",
        "TEXT_ASK_HELPER_TO_ACQUIT_INSITU_ALERT_CALL": "The carer is called back every 15 minutes until the alert is acquitted in situ",
        "TEXT_ASK_HELPER_TO_ACQUIT_ALERT_CALL": "The carer is called back every 15 minutes to acquit the alert by phone",
        "NO_OPTION": "The carer is not recalled",
        "PROCESS_ACTIONS_TYPE": "Type of scenario",
        "NUMBER_OF_CYCLE": "Number of cycles",
        "NUMBER_OF_CALL": "Number of times the scenario is played",
        "PROCESS_DESCRIPTION": "Process description",
        "PROCESS_NAME": "Process name",
        "RECEPTIONIST_NAME": "Helper's name",
        "CASCADE": "Sequential",
        "PARALLEL": "Simultaneous",
        "AUTOMATIC_CHOICE": "If possible, the system chooses automatically the closest helpers according to their geolocation",
        "AUTOMATIC_CHOICE_INFO": "Applies if helpers use the mobile app; else the user-chosen order applies.",
        "HELPERS_LIST_TITLE": "Notification cycle process",
        "HELPERS_LIST_MANDATORY": "At least one helper to be contacted must be defined",
        "AVAILABLE_HELPERS_LIST_TITLE": "Available helpers",
        "NO_AVAILABLE_HELPERS_TITLE": "There is no more helper to add",
        "ARROW_HINT_UP": "Up",
        "ARROW_HINT_DOWN": "Down",
        "ADD_TO_PROCESS_HINT": "Add to the list of helpers to call",
        "DELETE_FROM_PROCESS_HINT": "Do not contact this helper during this process",
        "ADD_NEW_ALERT_PROCESS": "Create a new process",
        "COPIED_PROCESS": "(Copy from {{templateName}})",
        "NEW_ALERT_PROCESS": "New ert process",
        "UPDATE_ALERT_PROCESS": "Change the process",
        "ERROR_PROCESS_NAME_ALREADY_EXIST": "This process name is already used",
        "ERROR_PROCESS_DATA_HELPER": "You must at least choose 1 helper",
        "TOASTR_SUCCESS": "The process list is up-to-date",
        "DISCLAIMER_DELETE_PROCESS": "<b>Deleting the process may cause a break in the alert chain if the process is still in use.</b><br>",
        "TECHNICAL_FORMAT_TEXT": "Use the concise format for the calls",
        "TECHNICAL_FORMAT_HELP": "<p>The concise format is a condensed format allowing quick access to the alert information.</p><div class='alert alert-success'>&laquoCo-assist alert. (Alert type), (User's name). Alert started (Duration) minutes ago, to take charge of the alert press the key 1&raquo</div>",
        "AFTER_HANLING": "After handling",
        "REWIND_PROCESS": "Restart alert process",
        "REWIND_PROCESS_MEANING": "Retry the process if no acknowledgment is received",
        "REWIND_PROCESS_DURATION_VALUE": "Duration in minutes before relaunch",
        "CONFIRMATION_DELETE_PROCESS": "Do you really want to delete this process?",
        "CALL": "Call on SDA",
        "PUBLIC_CALL": "Call on SDA",
        "PRIVATE_CALL": "Call on extension",
        "BREAK": "Pause",
        "PUSH_NOTIFICATION": "Mobile notification",
        "EMAIL": "Email notification",
        "SMS": "SMS notification",
        "WHATSAPP": "WhatsApp notification",
        "WEBHOOK": "Webhook",
        "EXTERNAL_PROCESS": "Child Process",
        "HINT_PARALLEL_ACTIONS": "Notifications will be sent simultaneously",
        "HINT_CASCADE_ACTIONS": "Notifications will be sent sequentially",
        "HINT_EXTERNAL_PROCESS": "To change notifications, go directly to the designated process",
        "ESPA": "ESPA",
        "ERROR_UNKNOWN_ACTION": "Unknown action",
        "NO_HELPER_AVAILABLE": "No helper available",
        "ALL_HELPERS_ALREADY_ADDED": "All available helpers have been added",
        "BREAK_ALREADY_ADDED": "You have already added a pause",
        "NO_WEBHOOK_AVAILABLE": "No webhook available",
        "NO_ESPA_AVAILABLE": "No ESPA available",
        "NB_EXECUTION": "Repeat",
        "INCREASE_LOOP": "Increase",
        "DECREASE_LOOP": "Decrease",
        "ADD_ACTION": "Add action",
        "REMOVE_ACTION": "Remove this action",
        "MUTIPLE_ACTION_DISABLED": "Only available for sequential scenarios",
        "NO_EXTERNAL_PROCESS": "No process available, please create a child process first",
        "SLAVE_PROCESS": "Child process",
        "DELETE_NOT_ALLOWED": "This child process cannot be deleted because it is called in a parent process",
        "SLAVE_CALLED": "This child process is called in a parent process",
        "MASTER_CALL": "(called by: {{masterCalled}})",
        "EDIT_SLAVE": "Edit child process",
        "ERROR_USER_DELETED_IN_PROCESS": "UTILISATEUR SUPPRIMÉ",
        "EMPTY_PROCESS": "Notification handled by hardware only"
    },
    "MANAGE_WEBHOOK": {
        "TITLE": "Webhook Management",
        "TITLE_CONFIGURATION": "Configuration",
        "TITLE_ID": "Identification",
        "NO_DESCRIPTION": "No description",
        "WEBHOOK_DESCRIPTION": "Webhook description",
        "WEBHOOK_NAME": "Webhook name",
        "ADD_NEW_WEBHOOK": "Create a webhook",
        "COPIED_WEBHOOK": "(Copy of {{templateName}})",
        "NEW_WEBHOOK": "New webhook",
        "UPDATE_WEBHOOK": "Edit webhook",
        "ERROR_WEBHOOK_NAME_ALREADY_EXIST": "This webhook name is already in use",
        "TOASTR_SUCCESS": "The webhook list has been updated",
        "DISCLAIMER_DELETE_WEBHOOK": "<b>Deleting the webhook may disrupt the alert chain if it is still in use.</b><br>",
        "CONFIRMATION_DELETE_WEBHOOK": "Do you really want to delete this webhook?"
    },
    "MANAGE_ESPA": {
        "TITLE": "Manage ESPA frame",
        "TITLE_ID": "Identification",
        "TITLE_ESPA": "ESPA",
        "TITLE_NOTIFICATION": "Notification",
        "TITLE_TRANSPORT": "Transport",
        "ESPA_DESCRIPTION": "ESPA frame description",
        "ESPA_NAME": "ESPA frame name",
        "ADD_NEW_ESPA": "Create an ESPA frame",
        "COPIED_ESPA": "(Copy of {{templateName}})",
        "NEW_ESPA": "New ESPA frame",
        "UPDATE_ESPA": "Edit ESPA frame",
        "ERROR_ESPA_NAME_ALREADY_EXIST": "This ESPA frame name is already in use",
        "TOASTR_SUCCESS": "The ESPA frame list has been updated",
        "DISCLAIMER_DELETE_ESPA": "<b>Deleting the ESPA frame may disrupt the alert chain if it is still in use.</b><br>",
        "CONFIRMATION_DELETE_ESPA": "Do you really want to delete this ESPA frame?",
        "ADVANCED_OPTIONS": "Advanced options (optional)",
        "HINT_HEADER": "block type placed right after SOH, locked to 1 (\"call to pager\", ESPA 4.4.4 §4.2): the only type relevant for sending an alert. Other types (status tracking, subscriber-line call) are not supported."
    },
    "MANAGE_HELPER": {
        "TITLE": "Manage helpers",
        "DIALOG_INFO": "<p>Helpers are people who are able to assist the user when an alert occur. The more helpers there are, the more likely one will be available during an alert.</p><p>Co-assist recommands to have at least 3 helpers, but only one is needed to make the service work.<p>",
        "IVR_TOOLTIP": "This user can be reached via an interactive voice response with extension {{ivrExtension}}",
        "CONNECTED_TO_MOBILE_APP": "Device connected to the application: {{number}}",
        "ERROR_LAST_HELPER": "You must have at least one helper",
        "ERROR_IVR_MAX_LENGTH": "The extension can't have more than {{maxLength}} characters",
        "MAIL_DELETED": "Double authentication code could not be sent anymore if email address is removed",
        "ADD_HELPER": {
            "ACTION": "Add a helper",
            "TITLE": "New helper",
            "BUTTON": "Add helper",
            "FINAL_BUTTON": "Finalize subscription",
            "CONFIRM_ADD_HELPER": "Do you want to validate the addition of the helpers?",
            "SUCCESS_WHATSAPP_VERIFICATION": "Your WhatsApp account is now linked",
            "SUCCESS_WHATSAPP_UNLINKED": "Your WhatsApp account is now unlinked"
        },
        "UPDATE_HELPER": {
            "TITLE": "Update of a user",
            "BUTTON": "Update helper"
        },
        "DELETE_HELPER": {
            "TITLE": "Deletion of a helper",
            "WARNING": "If the helper has no other connection, their account will be permanently deleted.",
            "WARNING_B2B": "The deletion of this helper results in its deletion from all other processes.",
            "CONFIRMATION": "Do you confirm the deletion of: {{name}}?"
        },
        "INFO": {
            "TITLE": "Helper information",
            "TEXT": "<b>Extension number</b><br/>In the case of an Interactive Voice Response system, allows you to reach a helper through his extension number (DECT)."
        }
    },
    "CONFIRMATION_ALERT": "Do you really want to delete the alert?",
    "zoneExit": "Exit from life area",
    "fall": "Fall detection",
    "button": "Watch's button press",
    "buttonBracelet": "Bracelet's button press",
    "buttonSole": "Medical alarm",
    "buttonCau1": "Patient call button",
    "buttonCau2": "Request for support",
    "buttonCall": "Direct call",
    "buttonCallTmt": "Pressing the mobile GPS button",
    "endOfLifeBattery": "Empty battery",
    "tilt": "Tilt detection",
    "inactivity": "Immobility detection",
    "criticalBattery": "Empty battery level",
    "lowBattery": "Low battery level",
    "smoke": "Smoke detection",
    "openDoor": "Door opening detection",
    "dc1": "Dry contact 1",
    "dc2": "Dry contact 2",
    "dc3": "Dry contact 3",
    "dc4": "Dry contact 4",
    "disconnection": "Disconnection",
    "nonFunctionnal": "Non functionnal device",
    "prolongedPresence": "Prolonged presence",
    "threshold": "Threshold exceeded",
    "leak": "Leak detection",
    "DEVICE_TYPE": {
        "BSSigfox": "Sigfox base station ",
        "BSLora": "LoRa base station",
        "BLEBeacon": "Location beacon BLE",
        "EV07BChargeBase": "EV07B Charge Base",
        "EV04ChargeBase": "EV04 Charge Base",
        "EV05ChargeBase": "EV05 Charge Base",
        "DS3604": "Display",
        "CAW": "Watch",
        "CAB": "Bracelet",
        "AlertUnit": "Alert unit",
        "SimplePack4.0Magnetic": "Door opening detector",
        "SimplePack4.0Button": "Simple button",
        "I870SF": "Smoke detector (public networks)",
        "I870LR": "Smoke detector (private networks)",
        "ZEPRLR": "Smoke detector",
        "ZEECDMINOLR": "Water meter",
        "_ZEECDMINOLR_hot": "Hot water meter",
        "_ZEECDMINOLR_cold": "Cold water meter",
        "LHT65NLR": "Temperature sensor",
        "GH5200": "Badge mobile GPS",
        "ARF8170BCA": "Dry Contact",
        "ARF8171BA": "Dry Contact",
        "TMT250": "Button mobile GPS",
        "EV07B": "Button mobile GPS",
        "EV04": "Button mobile GPS",
        "EV05": "GPS Watch",
        "Smartphone": "Smartphone",
        "SmartDati": "SmartDati",
        "CAU": "Alert unit",
        "CALAU": "Alert unit",
        "CALDryContact": "Dry Contact",
        "CALBeacon": "Beacon",
        "CALDS": "Door opening detector",
        "CALPear": "Bed panic button",
        "CALToggle": "Pull cords",
        "CoAssistAppVirtual": "Co-assist mobile app",
        "Luna4G": "Luna Station",
        "TAGID": "Tag",
        "CALWornBracelet": "Worn bracelet",
        "CALSimpleButton": "Simple button",
        "NetworkDevice": "Network device",
        "LDS02DS": "Door opening detector",
        "LDS02SimpleButton": "Simple button",
        "VH2BBUS01": "Radar",
        "WSM02": "Bed occupancy sensor",
        "X865LSOrigin": "Smoke detector",
        "X855LSGuard": "Smoke detector",
        "X870LSOriginPlus": "Smoke detector",
        "X860LSGuardPlus": "Smoke detector",
        "CALAlertUnit": "Alert unit",
        "DS3604Display": "Display",
        "LA66USB": "LoRa network scanner",
        "LC01": "LoRaWAN relay",
        "LC04": "LoRaWAN relay",
        "Tunstall": "W9 bracelet",
        "undefined": "Unknown"
    },
    "DEVICE": {
        "TITLE_MODAL": "Equipement settings",
        "FLESPI_SETTINGS": {
            "TOOLTIP": "Device settings",
            "TITLE": "Device settings",
            "ERROR": "Unable to retrieve the device settings.",
            "WRITE_PENDING": "A change is waiting for the device, refresh is suspended.",
            "UNREACHABLE": "Device unreachable: the last known value is displayed. Your changes will be received and executed as soon as it is connected again.",
            "UP_TO_DATE": "Up to date: just read from the device.",
            "NO_VALUE": "No value: the device has never reported.",
            "LAST_UPDATE": "Last update: {{date}}",
            "CONNECTION_HINT": "Changes are applied as soon as the device is connected.",
            "REFRESH": "Refresh",
            "SAVE": "Save",
            "SAVE_CONFIRMED": "Saved: the device confirmed the change.",
            "SAVE_PENDING": "Saved: waiting for the device, the change will be applied the next time it connects.",
            "LANGUAGE": {
                "TITLE": "Language",
                "NO_VALUE": "Unknown",
                "PENDING": "Waiting for the device",
                "OPTIONS": {
                    "fr": "Français",
                    "en-US": "English"
                }
            },
            "PHONE": {
                "TITLE": "Number {{index}}",
                "ENABLE": "Enabled",
                "NUMBER": "Number",
                "NUMBER_INVALID": "Invalid number: digits only (leading \"+\" allowed), 20 characters maximum.",
                "TOOLTIP_CALL": "Sending a call",
                "TOOLTIP_SMS": "Sending an SMS",
                "TOOLTIP_ENABLE": "Number activation",
                "CLICK_TO_DISABLE": "Click to disable",
                "CLICK_TO_ENABLE": "Click to enable",
                "ACCEPT_PHONE_CALL": "Sends a call",
                "ACCEPT_SMS": "Sends an SMS",
                "NO_VALUE": "No value",
                "PENDING": "Waiting for the device"
            }
        },
        "TITLE": "{{moduleID}} Watch settings",
        "TITLE_BLEBeacon": "{{moduleID}} Beacon BLE settings",
        "TITLE_EV07BChargeBase": "{{moduleID}} EV07B Charge Base",
        "TITLE_EV04ChargeBase": "{{moduleID}} EV04 Charge Base",
        "TITLE_EV05ChargeBase": "{{moduleID}} EV05 Charge Base",
        "TITLE_CAW": "{{moduleID}} Watch settings",
        "TITLE_CAW_UNSYNC": "{{moduleID}} Watch settings are unsynchronized",
        "TITLE_CAB": "{{moduleID}} Bracelet settings",
        "TITLE_DS3604": "{{moduleID}} Beacon BLE settings",
        "TITLE_AlertUnit": "{{moduleID}} Alert unit settings",
        "TITLE_CALAlertUnit": "{{moduleID}} Alert unit settings",
        "TITLE_SimplePack4.0Magnetic": "{{moduleID}} Door opening detector settings",
        "TITLE_SimplePack4.0Button": "{{moduleID}} Medical alarm settings",
        "TITLE_I870SF": "{{moduleID}} Smoke detector settings",
        "TITLE_I870LR": "{{moduleID}} Smoke detector settings",
        "TITLE_ZEPRLR": "{{moduleID}} Smoke detector settings",
        "TITLE_ZEECDMINOLR": "{{moduleID}} Water meter settings",
        "TITLE_ZEECDMINOLR_hot": "Hot water meter settings {{moduleID}}",
        "TITLE_ZEECDMINOLR_cold": "Cold water meter settings {{moduleID}}",
        "TITLE_LHT65NLR": "{{moduleID}} Temperature sensor settings",
        "TITLE_GH5200": "{{moduleID}} Badge mobile GPS settings",
        "TITLE_TMT250": "{{moduleID}} Button mobile GPS settings",
        "TITLE_EV07B": "{{moduleID}} Button mobile GPS settings",
        "TITLE_EV04": "{{moduleID}} Button mobile GPS settings",
        "TITLE_EV05": "{{moduleID}} GPS watch settings",
        "TITLE_SmartDati": "{{moduleID}} SmartDati settings",
        "TITLE_ARF8170BCA": "{{moduleID}} Dry contact settings",
        "TITLE_ARF8171BA": "{{moduleID}} Dry contact settings",
        "TITLE_CALDS": "{{moduleID}} Door opening detector settings",
        "TITLE_CALDryContact": "{{moduleID}} Dry contact settings",
        "TITLE_CALBeacon": "{{moduleID}} Beacon settings",
        "TITLE_CALToggle": "{{moduleID}} Bed panic button settings",
        "TITLE_Luna4G": "{{moduleID}} Luna Station settings",
        "TITLE_TAGID": "No settings available for {{moduleID}}",
        "TITLE_CALPear": "{{moduleID}} Pull cords settings",
        "TITLE_CALWornBracelet": "{{moduleID}} Worn bracelet settings",
        "TITLE_CALSimpleButton": "{{moduleID}} Simple button settings",
        "TITLE_NetworkDevice": "Network device",
        "TITLE_LDS02DS": "{{moduleID}} Door opening detector settings",
        "TITLE_LDS02SimpleButton": "{{moduleID}} Simple button settings",
        "TITLE_VH2BBUS01": "{{moduleID}} Radar settings",
        "TITLE_X865LSOrigin": "{{moduleID} Smoke detector settings",
        "TITLE_X855LSGuard": "{{moduleID} Smoke detector settings",
        "TITLE_X870LSOriginPlus": "{{moduleID} Smoke detector settings",
        "TITLE_X860LSGuardPlus": "{{moduleID} Smoke detector settings",
        "TITLE_WSM02": "{{moduleID}} Bed occupancy sensor settings",
        "TITLE_DEFAULT": "Default watch settings",
        "TITLE_B2B": "Alert profiles configuration",
        "HINT_INFO": "More information",
        "DIALOG_INFO_CAW": "The equipment settings is defined in this page. For modifications to be taken into account, please put the watch on a charger.",
        "DIALOG_INFO_CAB": "The equipment settings is defined in this page.",
        "DIALOG_INFO_AlertUnit": "The equipment settings is defined in this page.",
        "DIALOG_INFO_CALAlertUnit": "The equipment settings is defined in this page.",
        "DIALOG_INFO_SimplePack4.0Magnetic": "The door opening detector settings is defined in this page.",
        "DIALOG_INFO_SimplePack4.0Button": "The medical alarm settings is defined in this page.",
        "DIALOG_INFO_I870SF": "The equipment settings is defined in this page.",
        "DIALOG_INFO_I870LR": "The equipment settings is defined in this page.",
        "DIALOG_INFO_ZEPRLR": "The equipment settings is defined in this page.",
        "DIALOG_INFO_X865LSOrigin": "The equipment settings is defined in this page.",
        "DIALOG_INFO_X855LSGuard": "The equipment settings is defined in this page.",
        "DIALOG_INFO_X870LSOriginPlus": "The equipment settings is defined in this page.",
        "DIALOG_INFO_X860LSGuardPlus": "The equipment settings is defined in this page.",
        "DIALOG_INFO_ZEECDMINOLR": "The equipment settings is defined in this page.",
        "DIALOG_INFO_LHT65NLR": "The equipment settings is defined in this page.",
        "DIALOG_INFO_GH5200": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/notice-badge-gps' target='_blank'>Acces to the badge mobile GPS user guide</a>",
        "DIALOG_INFO_TMT250": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Acces to the button mobile GPS user guide</a>",
        "DIALOG_INFO_EV07B": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Acces to the button mobile GPS user guide</a>",
        "DIALOG_INFO_EV04": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Acces to the button mobile GPS user guide</a>",
        "DIALOG_INFO_EV05": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Acces to the button mobile GPS user guide</a>",
        "DIALOG_INFO_SmartDati": "<p>The equipment settings is defined in this page.",
        "DIALOG_INFO_ARF8170BCA": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/contact-sec-installation' target='_blank'>Acces to the dry contact user guide</a>",
        "DIALOG_INFO_ARF8171BA": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/contact-sec-installation' target='_blank'>Acces to the dry contact user guide</a>",
        "DIALOG_INFO_DS3604": "The equipment settings is defined in this page.",
        "DIALOG_INFO_BLEBeacon": "The equipment settings is defined in this page.",
        "DIALOG_INFO_EV07BChargeBase": "The equipment settings is defined in this page.",
        "DIALOG_INFO_EV04ChargeBase": "The equipment settings is defined in this page.",
        "DIALOG_INFO_EV05ChargeBase": "The equipment settings is defined in this page.",
        "DIALOG_INFO_CALDryContact": "<p>The equipment settings is defined in this page.</p><a href='https://support.co-assist.fr/contact-sec-installation' target='_blank'>Acces to the dry contact user guide</a>",
        "DIALOG_INFO_CALDS": "The door opening detector settings is defined in this page.",
        "DIALOG_INFO_CALToggle": "The bed panic button settings is defined in this page.",
        "DIALOG_INFO_CoAssistAppVirtual": "The backup request settings is defined in this page.",
        "DIALOG_INFO_Luna4G": "The Luna Station settings is defined in this page.",
        "DIALOG_INFO_TAGID": "Nothing to define.",
        "DIALOG_INFO_CALPear": "The pull cords settings is defined in this page.",
        "DIALOG_INFO_CALWornBracelet": "The worn bracelet settings is defined in this page.",
        "DIALOG_INFO_CALSimpleButton": "The simple button settings is defined in this page.",
        "DIALOG_INFO_LDS02DS": "The door opening detector settings is defined in this page.",
        "DIALOG_INFO_LDS02SimpleButton": "The simple button settings is defined in this page.",
        "DIALOG_INFO_VH2BBUS01": "The radar settings is defined in this page.",
        "DIALOG_INFO_WSM02": "The bed occupancy sensor is defined in this page.",
        "UNAVAILABLE_FUNCTIONS": "The software version of your watch does not allow you to benefit from this feature. Contact support for more information.",
        "UNAVAILABLE_MODULE": "This user has no associated watch or bracelet. Contact support for more information.",
        "HAVE_UPDATED_ALERT": "You have updated the alert",
        "HAVE_UPDATED_SETTING": "You have updated the setting",
        "COPY_CONFIGURATION_TITLE": "Duplicate the configuration",
        "COPY_CONFIGURATION_BODY": "Select the alerts on which to apply the configuration <strong>&laquo;{{alert}}&raquo;</strong>",
        "SAVE_ALERT_SETTINGS": {
            "ACTION": "Save this configuration as the default configuration.",
            "ACTION_B2B": "I wish to keep the user's configuration",
            "SUCCESS": "The default configuration has been saved"
        },
        "RESET_ALERT_SETTINGS": {
            "USER_ACTION": "Reset to user's default configuration",
            "NO_USER_ACTION": "There is no default configuration to restore",
            "GROUP_ACTION": "Apply an alert profile",
            "SUCCESS": "The configuration has been applied to the user"
        },
        "APPLY_DEFAULT": {
            "ALERTS_ACTION": "Propagate alert profile",
            "CONFIG_ACTION": "Propagate configuration",
            "TITLE": "Choose the configuration to apply",
            "OPTIONS": {
                "APPLY_ALL_SETTINGS": "Apply all settings (excluding position monitoring)",
                "APPLY_ALL_USERS": "Apply all users",
                "SELECT_SETTINGS": "Select the settings to apply",
                "SELECT_USERS": "Select the users to apply",
                "SELECT_DEVICE_TYPES": "Selec the equipment",
                "APPLY_ALL_DEVICE_TYPES": "Apply all equipments"
            },
            "CONFIRM": "The chosen alert profile will override all the old configurations.",
            "SUCCESS": "The chosen configuration has been applied to selected users"
        },
        "CONFIG_ALERTS": {
            "TITLE": "Alert settings",
            "HINT_SCHEDULE": "Planning of notification sets",
            "HINT_button": "Press duration",
            "HINT_zoneExit": "Delimitation of the living area",
            "HINT_CONFIG": "Notification sets configuration",
            "HINT_ALERT_LATENCY": "Alert responsiveness",
            "HINT_ALERT_THRESHOLD": "Threshold definition",
            "HINT_PROBE_PRESENCE": "Probe presence",
            "WARNING_REAL_TIME_TRACKER": "Caution: Activating the position tracker will greatly reduce the battery life of the watch. To use the position tracking effectively, you must be trained in its use. Do not hesitate to contact Customer Service if you have any questions.",
            "DESCRIPTION": {
                "criticalBattery": "If this option is activated, an alert is automatically launched when the watch runs out of battery.",
                "lowBattery": "If this option is activated, an alert is automatically launched when the battery level reaches 15%.",
                "alertDuration": "Alert timing is the time during which the alert can be canceled or closed when used in a nursing home",
                "inactivity": "This feature allows to detect when the watch is still during a set period of time (alert reactivity). The minimum reactivity period, 1h30, is the time needed to be sure that the watch is fully stationary, and not in a comparable situation such as the user's sleep. Setting a longer reactivity period allows you to adapt to the actual watch usage, for example when the user doesn't want to wear the watch at night. Usually, an immobility alert signifies that the watch isn't worn by the user.",
                "zoneExit": "If this option is activated, the location of the user is automatically sent, when moves are detected. Usually, accuracy is around a few kilometers indoor and few meters outdoor. Accurate location can be found outdoor only if the user is still or moves at a normal pace. To cancel a zone exit alert, the user must go back into their life area.",
                "tilt": "If this option is activated, the equipment triggers an alert when it stays tilted beyond the threshold set on the device.",
                "fall": "If this option is activated, the watch automatically detects heavy falls followed by no movement for a few seconds. In case of a fall, the watch vibrates and a small light flashes. To cancel a fall alert, the alert button must be pressed for several seconds; the watch vibrates again and the flash stops.",
                "button": "If this option is activated, the alert button allows to call for an emergency. If the alert button is pressed, the watch vibrates and a small light flashes. To cancel an alert, the alert button must be pressed for several seconds; the watch vibrates again and the flash stops.",
                "buttonBracelet": "If this option is enabled, the alert button on the wristband allows alerts to be sent. When the button is pressed, the watch vibrates and a small light flashes. To cancel the sending of an alert, the alert button must be pressed for a few seconds. The watch vibrates again and the flashing of the small light stops.",
                "buttonSole": "If this option is activated, the sick call will send alerts when the button is pressed. To acknowledge the alert, the magnetic card must be passed over the sick call.",
                "buttonCau1": "If this option is activated, the alert unit unit can send alerts when the button is pressed. To acknowledge the alert, the magnetic card must be swiped over the sick call unit.",
                "buttonCau2": "If this option is activated, the alert unit can send a request for reinforcement.",
                "buttonCall": "This option cannot be disabled, the alarm button on the badge mobile GPS allows a call to be made from the badge to a pre-configured number.",
                "buttonTmt": "This option cannot be disabled, the alarm button on the button mobile GPS allows an SMS to be made from the badge to a pre-configured number.",
                "smoke": "If this option is enabled, an alert is automatically sent when the device detects smoke.",
                "endOfLifeBattery": "If this option is enabled, an alert is automatically sent when the battery level is critical and the device needs to be replaced.",
                "openDoor": "If this option is enabled, an alert is automatically sent when the equipment detects that the door is open.",
                "dc1": "If this option is enabled, an alert is automatically sent when the equipment launch an alarm.",
                "dc2": "If this option is enabled, an alert is automatically sent when the equipment launch an alarm.",
                "dc3": "If this option is enabled, an alert is automatically sent when the equipment launch an alarm.",
                "dc4": "If this option is enabled, an alert is automatically sent when the equipment launch an alarm.",
                "disconnection": "If this option is activated, an alert is automatically launched when the device is disconnected",
                "nonFunctionnal": "If this option is activated, an alert is automatically launched when the device is disconnected",
                "prolongedPresence": "If this option is activated, an alert is automatically launched when the user is still during a long time",
                "threshold": "If this option is enabled, an alert is issued if the device exceeds the configured threshold.",
                "leak": "If this option is enabled, an alert is issued if the device detects a leak."
            },
            "DEACTIVATION": {
                "TITLE": "Deactivation of {{name}}",
                "CONTENT": "Are you sure you want to disable this alert?",
                "POSITION_TRACKING": "Do you also want to disable location tracking?",
                "ZONE_EXIT": "Zone exit alert uses location tracking. Do you confirm the deactivation of location tracking and zone exit alert?"
            },
            "ACTIVATION": {
                "POSITION_TRACKING_LEGAL": "CO-ASSIST is fully committed to insure integrity and confidentiality of geolocation data. CO-ASSIST subscribed to the French Silver Economy Chart of good practices in locating in gerontology for people suffering from dementia. Use of the location functionality requires the express prior consent of the user or of one helper having a mandate to act in name and on behalf of the user. Data are saved for a maximum of two (2) years for CO-ASSIST's internal use only. This service follows CO-ASSIST's Terms of Service."
            },
            "ACTION_SUMMARY": {
                "none": "No notification defined",
                "smss": "Text message to {{item}}",
                "emails": "Email to {{item}}",
                "calls": "Phone call to {{item}}",
                "technicalSmss": "Concise text message to {{item}}",
                "technicalEmails": "Concise email to {{item}}",
                "technicalCalls": "Concise phone call to {{item}}",
                "processID": "Process \"{{item}}\"",
                "webhooks": "Webhook to \"{{item}}\"",
                "whatsApps": "Send a WhatsApp message to {{item}}",
                "pushNotifications": "Notification to {{item}}",
                "warning": "PLEASE NOTE: No helper number for WhatsApp alerts"
            },
            "MISSING_ACTIONS": {
                "TITLE": "Missing alert notification",
                "TEXT_SINGLE": "Warning, no notification has been defined for the following active alert:",
                "TEXT_PLURAL": "Warning, no notification has been defined for the following active alerts:",
                "TEXT_2_SINGLE": "This alert will not be sent to anyone. To set a notification, please click on the cogwheel beside the alert.",
                "TEXT_2_PLURAL": "These alerts will not be sent to anyone. To set a notification, please click on the cogwheel beside each alert."
            },
            "ALERT_SETTING": {
                "LIFE_AREA": "Delimitation of the living area",
                "LATENCY": {
                    "TITLE": "Alert responsiveness",
                    "MIN_LAT_SUBTITLE": "How long after the event do you want to be alerted (minimum 1h30)?",
                    "SUBTITLE": "How long after the event do you want to be alerted  ?",
                    "MINIMUM_LATENCY_ERROR": "The responsiveness of this alert can't be under {{minimumLatency}}",
                    "MAXIMUM_LATENCY_ERROR": "The responsiveness of this alert cannot exceed {{maximumLatency}}",
                    "NO_DELAY": "No delay",
                    "PLACEHOLDER": "Alert reactivity"
                },
                "PROBE_PRESENCE": {
                    "TITLE": "Probe link with the temperature sensor",
                    "BODY": "In order to have more accurate samples, it is possible to connect a probe to the temperature sensor LHT65N. Is the probe linked?",
                    "PLACEHOLDER": "Probe linked"
                },
                "THRESHOLD": {
                    "TITLE": "Threshold trigger"
                },
                "BUTTON_PRESS": {
                    "TITLE_WARNING": "Press duration. Only available from the 2.5 version",
                    "TITLE": "Press duration",
                    "SUBTITLE": "Do you prefer a long or short press duration to start a button alert?",
                    "WARNING": "Only available from the 2.5 version",
                    "PLACEHOLDER": "Press duration",
                    "SHORT": "Short",
                    "LONG": "Long"
                }
            },
            "ALERT_ACTION": {
                "TITLE": "Notifications sets",
                "TAB_SETTINGS": "Settings",
                "TAB_NOTIFICATIONS": "Notifications",
                "TITLE_LIST": "Notification set",
                "TYPE": {
                    "smss": "Text message",
                    "emails": "Email",
                    "calls": "Phone call",
                    "technicalSmss": "Concise text message",
                    "technicalEmails": "Concise email",
                    "technicalCalls": "Concise phone call",
                    "processID": "Launch notification process",
                    "webhooks": "Setup a webhook",
                    "whatsApps": "Send a WhatsApp message",
                    "pushNotifications": "Notify the mobile application"
                },
                "TECHNICAL_FORMAT": {
                    "smss": "<p>There are two types of sms format, a more verbose standard format and a more condensed Concise format.</p><br/><p>Standard format : </p><div class='alert alert-success'>Alert: button press. <br/>Hello,<br/>The alert button of (User's name)'s watch has been pressed.</div><p>Technical format : </p><div class='alert alert-success'>Alert: (Alert type),<br/>User: (User's name),<br/>userID: (User ID),<br/>alertID: (Alert ID)</div>",
                    "emails": "<p>There are two types of emails format, a more verbose standard format and a more condensed Concise format.</p><br/><p>Standard format : </p><div class='alert alert-success'>The alert button of (User's name)'s watch has been pressed.<br/>For further information, please log on to your web account on https://compte.co-assist.fr or on the mobile app.</div><p>Technical format : </p><div class='alert alert-success'>Alert: (Alert type),<br/>User: (User's name),<br/>userID: (User ID),<br/>alertID: (Alert ID)</div>",
                    "calls": "<p>There are two types of calls format, a more verbose standard format and a more condensed Concise format.</p><br/><p>Standard format : </p><div class='alert alert-success'>&laquoHello, The alert button of (User's name)'s watch has been pressed. Please, can you assist him or her ?&raquo</div><p>Technical format : </p><div class='alert alert-success'>&laquoCo-assist alert. (Alert type), (User's name)&raquo</div>",
                    "webhooks": "<p>Le body standard is like :<pre>{<br/>type: 'alert',<br/>payload: {<br/>userID: string,<br/>alertID: string,<br/>alertType: string, // ex: 'fall'<br/>alertStatus: string,<br/>startTimeMs: number,<br/>lastStatusUpdateMs: number,<br/>displayName: string}<br/>}<br/></pre></p>",
                    "whatsApps": "<p>If the desired helper does not appear, please first associate a WhatsApp number with them in the “Helpers and processes” tab</p>"
                },
                "ADD_ACTION": "Add a notification",
                "ADD_CONFIGURATION": "Add a new notification set",
                "DELETE_CONFIGURATION": "Delete the current notification set",
                "COLUMN_TYPE": "Type",
                "COLUMN_VALUE": "Value",
                "COLUMN_ACTIONS": "Actions",
                "SELECT_TYPE": "Select",
                "UNKNOWN_TYPE": "",
                "SELECT_PROCESS": "Select a process",
                "SELECT_USERS": "Select who will receive notifications",
                "EMPTY_NOTIFICATIONS": "You must have at least one notification set up.",
                "ALREADY_HAS_PROCESS": "A process is already active.",
                "INFOS": "<p>A notification set is a set of notifications (one or more) issued during an alert.</p><div class='alert alert-success'>Example: I can define a notification set named &laquo;Morning&raquo; which corresponds to sending an email to &laquo;exemple@co-assist.fr&raquo; and an sms to &laquo;0600000000&raquo;. <br>In case of an alert I will be notified as defined in the notification set &laquo;Morning&raquo;.</div><p>In case of the use of scheduling, it is possible to define several notification sets in order to have differentiated notifications according to the time slot (example of use case: separate notifications day/night, week/weekend).</p>"
            }
        },
        "CONFIG_DEVICE": {
            "TITLE": "Settings",
            "DESCRIPTION": {
                "realTimeTracker_CAW": "Caution: Activating the position tracker will greatly reduce the battery life of the watch. To use the position tracking effectively, you must be trained in its use. Do not hesitate to contact Customer Service if you have any questions.",
                "realTimeTracker_GH5200": "This option cannot be disabled, the user's position is recorded and transmitted when the user is in motion, at a preset frequency.",
                "realTimeTracker_TMT250": "This option cannot be disabled, the user's position is recorded and transmitted when the user is in motion, at a preset frequency.",
                "realTimeTracker_EV07B": "This option cannot be disabled, the user's position is recorded and transmitted when the user is in motion, at a preset frequency.",
                "realTimeTracker_EV04": "This option cannot be disabled, the user's position is recorded and transmitted when the user is in motion, at a preset frequency.",
                "realTimeTracker_EV05": "This option cannot be disabled, the user's position is recorded and transmitted when the user is in motion, at a preset frequency.",
                "timezone": "This feature allows you to set the time zone of the user's watch.",
                "display": "This feature allows you to change the time display of the user's watch.",
                "button_long_pressure": "This feature allows you to change the length of time you need to physically press the button on your watch to trigger an alert."
            }
        },
        "CONFIG_PROFILE": {
            "ADD": "Add a new alert profile",
            "SET_NAME_TITLE": "New profile creation",
            "SET_NAME": "Profile name",
            "COPY_PROFILE": "Copy existing profile",
            "DO_NOT_COPY": "Do nothing",
            "DIALOG": {
                "TITLE": "Deletion of '{{name}}' profile",
                "BODY": "Do you confirm?"
            }
        }
    },
    "POSITION": {
        "GET_HISTORY": "Search",
        "HISTORY_BUTTON": "Location",
        "NONE_POSITION": "No location available",
        "POSITION_DATE": "Location date:",
        "POSITION_ADDRESS": "Address:",
        "POSITION_ACCURACY": "Accuracy:",
        "VERY_GOOD": "Excellent",
        "GOOD": "Good",
        "BAD": "Limited",
        "ACQUIRED": "Location range",
        "FROM": "From",
        "TO": "To",
        "LOAD_MORE": "Load {{number}} additional positions"
    },
    "ALERT_DIAGRAM": {
        "TITLE": "Histogram of alerts"
    },
    "ALERT_HISTORY": {
        "TITLE": "Alerts history",
        "SELECT_TITLE": "Since",
        "EXPORT_CSV": "Download to CSV",
        "EXPORT_SELECTION_CSV": "Download selection to CSV",
        "FILTERED_EXPORT": "Export contains only filtered alerts",
        "DETECTED_ALERT": "Alerts have been detected during the selected period",
        "NO_ALERT": "No alert has been detected during the selected period",
        "ALERT_INFOS": "{{alertID}} Details view",
        "FILTER_ALL": "All alerts",
        "COLLECTIVE_ACT": "Qualify the entire selection",
        "FILTER": {
            "NO_MATCHING_ALERT": "No data matching the filter {{filter}}",
            "LABEL": "Filter",
            "EXAMPLE": "Type, device, user, etc.",
            "TOOLTIP": "Filter by alert type, device, user or qualification"
        }
    },
    "POSITION_DASHBOARD": {
        "TITLE": "Last estimated location"
    },
    "STATUS": {
        "TITLE": "Active alerts",
        "DIALOG_INFO": "An active alert is an alert that has not yet been acknowledged, closed or expired.",
        "STATUS_OK": "No alerts in progress",
        "AUTO_REFRESH": "Automatic refresh every 30 seconds",
        "DESCRIPTION": {
            "fall": "{{displayName}}'s watch has detected a fall.",
            "tilt": "{{displayName}}'s equipment has detected a tilt.",
            "fall.VH2BBUS01": "{{displayName}}'s radar has detected a fall.",
            "button": "{{displayName}}'s watch alert button has been pressed.",
            "buttonBracelet": "{{displayName}}'s bracelet button has been pressed.",
            "buttonSole": "{{displayName}}'s medical alarm button has been pressed.",
            "buttonCau1": "{{displayName}} pressed the button on his alert unit.",
            "buttonCau2": "Reinforcement is requested for {{displayName}}.",
            "buttonCall": "{{displayName}}'s badge mobile GPS alarm button has been pressed.",
            "buttonTmt": "{{displayName}}'s button mobile GPS alarm button has been pressed.",
            "inactivity": "{{displayName}}'s equipment has not detected any movement.",
            "lowBattery": "{{displayName}}'s device battery needs to be recharged.",
            "criticalBattery": "{{displayName}}'s device battery is empty.",
            "zoneExit": "{{displayName}} has left from the life area.",
            "smoke": "The {{displayName}}'s smoke detector has detected smoke.",
            "openDoor": "The {{displayName}}'s door has been opened.",
            "dc1": "{{displayName}}'s dry contact 1 launched an alert.",
            "dc2": "{{displayName}}'s dry contact 2 launched an alert.",
            "dc3": "{{displayName}}'s dry contact 3 launched an alert.",
            "dc4": "{{displayName}}'s dry contact 4 launched an alert.",
            "disconnection": "{{displayName}}'s radar analyser is disconnected.",
            "nonFunctionnal": "{{displayName}}'s device is not functionnal.",
            "prolongedPresence": "{{displayName}}'s radar detected a prolonged presence.",
            "threshold": "The {{displayName}} device threshold has been exceeded.",
            "leak": "The {{displayName}} device has detected a leak."
        },
        "ALERTS_HISTORY": "View alert history"
    },
    "SYSTEM_STATUS": {
        "NO_DEVICE": "No device associated",
        "TITLE": "Service status",
        "ACTIVATE_MODULE": "Confirm the order delivery of the watch",
        "INACTIVE_INFO": "Service deactivated during shipping.",
        "DIALOG_INFO": "A daily automated check-up is made to ensure user's safety.",
        "STATUS_OK": "All good!",
        "STATUS_ISSUE": "Last two daily check-up messages have not been received",
        "STATUS_ISSUE_LAST_HOUR": "Last control message received over an hour ago",
        "MOUSEOVER_TEXT": "Place your watch on the charging pad",
        "STATUS_WARNING": "Please put the watch on the charging pad for check-up",
        "STATUS_UNKNOWN": "No information available",
        "LAST_UPDATE_TITLE": "Last update",
        "LAST_UPDATE": "Last message received on {{date}}",
        "BATTERY_TITLE": "Battery level",
        "CONNECTIVITY_TITLE": "Connectivity",
        "UPDATE_TITLE": "Settings update",
        "WATCH_UP_TO_DATE": "Settings are up-to-date",
        "WATCH_NOT_UP_TO_DATE": "After validation of your configuration, please put your watch on the charger to synchronize it",
        "LORA_LOCATION_TITLE": "Device location"
    },
    "PROFILE": {
        "TITLE": "Profile of {{name}}",
        "UPDATE_SUCCESS": "Modifications saved",
        "MY_GROUP": {
            "TITLE": "My entity",
            "GROUP_ID": "Entity ID",
            "GROUP_NAME": "Entity name",
            "GROUP_ADDRESS": "Entity address",
            "IVR_EXPRESSION": "IVR configuration",
            "IVR_EXPRESSION_DIALOG": {
                "TITLE": "IVR configuration (Interactive Voice Response)",
                "WARNING": "A change in the configuration will impact the alert chain.",
                "MORE_INFO": "For more information please reach our customer service at 02 78 34 04 51.",
                "ACTIONS_TITLE": "Actions performed on the IVR",
                "ACTIONS": {
                    "play": "Enter {{value}}",
                    "pause": "Wait {{value}}",
                    "END": "Beginning of the alert message."
                },
                "THEN": " then ",
                "USER_EXT": "helper's extension number",
                "INVALID_EXPRESSION": "The configuration is invalid",
                "ERROR_TOO_LONG": "The total waiting time cannot exceed {{maxLength}} seconds",
                "ERROR_TOO_MUCH_ACTIONS": "The configuration cannot exceed {{maxLength}} actions"
            },
            "IVR_EXPRESSION_RESET_DIALOG": {
                "TITLE": "Reset the IVR configuration",
                "TEXT": "Would you like to restore the default configuration?"
            },
            "IVR_EXPRESSION_HELP_DIALOG": {
                "TITLE": "IVR configuration",
                "TEXT": "The IVR configuration allows you to create a sequence of actions that will be performed when a call is made on a PBX in order to reach a helper through his extension.<br>Since each voice server can be unique, it may be necessary to create a specific sequence of actions.<br><br>The sequence of actions will ends automatically by the beginning of the alert message <b>\"Hello, here the Co-assist warning service ...\"</b>.<br><br>Syntax for IVR configuration :<br>- each action is separated by a dash <b>-</b><br>- wait x second(s) : number greater or equal than <b>1</b><br>- enter one or more keys : <b>[*</b> or <b>#</b> or numbers from <b>0</b> to <b>9]</b><br>- enter the extension of the helper to contact : <b>H</b><br><br>Example : <b>1-[#0]-3-H-2</b><br><br>Default behavior : <span class=\"actions\">Wait 1 second</span> then <span class=\"actions\">Enter helper's extension number</span> then <span class=\"actions\">Wait 5 seconds</span> then <span class=\"actions\">Beginning of the alert message</span>."
            },
            "PBX_CONFIG": "PBX configuration (SIP)",
            "PBX_CONFIG_NONE": "No configuration",
            "PBX_CONFIG_DIALOG": {
                "TITLE": "PBX configuration (SIP)",
                "WARNING": "These credentials allow the server to call the group users. An incorrect configuration may prevent calls from being placed.",
                "PBX_HOST": "PBX host",
                "PBX_PORT": "Port",
                "EXTENSION": "Extension (From)",
                "PASSWORD": "Password",
                "TRANSPORT": "Transport",
                "SHOW_HIDE_PASSWORD": "Show/hide password"
            },
            "PBX_CONFIG_RESET_DIALOG": {
                "TITLE": "Delete PBX configuration",
                "TEXT": "Are you sure you want to delete this group's PBX configuration? Calls will no longer be placed."
            }
        },
        "FURTHER_INFORMATION": {
            "CONFIRM_DELETE_TITLE": "Deletion",
            "CONFIRM_DELETE_TEXT": "Are you sure you want to delete this information from the list?",
            "TITLE": "Information to be communicated to the helpers",
            "SUBTITLE": "You can enter here confidential information that will be available to helpers (example: birth date, entry code, floor, keys' location, caretaker's phone number, neighbor's phone number, doctor's number, medical info, blood type, etc.).",
            "DIALOG_INFO": "This information is strictly confidential, the user remains solely responsible for the information provided.",
            "ADD_INFORMATIONS": "Add this information",
            "EMPTY_INFORMATIONS": "Empty data",
            "TABLE": {
                "INFORMATION": "Information",
                "DESCRIPTION": "Description"
            }
        },
        "NEW_PASSWORD": {
            "TITLE": "Password",
            "TOAST": {
                "EMAIL_PASSWORD": "You will receive a confirmation email"
            }
        },
        "UPDATE_LOGIN_ID": {
            "TITLE": "Update your login ID",
            "ALREADY_TAKEN": "The login ID {{loginID}} isn't available",
            "INVALID": "The login ID {{loginID}} is invalid",
            "HINT": "first.lastname, name@email.com, etc.",
            "TOOLTIP": "Between 4 and 50 characters. Accented letters, digits, and @ . _ - are permitted. Spaces and other special characters are prohibited."
        },
        "RENEW_SECRET_KEY": {
            "TITLE": "QR code for the OTP app",
            "DISCLAIMER": "I confirm that I understand displaying the QR code generates a new key and invalidates the previous one.",
            "SHOW": "Show QR code for OTP app",
            "SCAN": "Scan the QR code above to add the security key to your OTP app (Authenticator, FreeOTP, etc.).",
            "WARN": "This key is linked to your user account and must not be shared."
        }
    },
    "TIMEZONE": {
        "LABEL": "Time zone",
        "FILTER": "Select your time zone",
        "EMPTY": "No matches found"
    },
    "MAP": {
        "CENTER": "center",
        "HOME": "Home"
    },
    "BATTERY": {
        "TITLE": "Battery level ",
        "UNKNOWN_BATTERY": "Unknown battery level",
        "THRESHOLD_LOW": {
            "TITLE": "Low {{lvl}}%",
            "SUBTITLE": "Battery level unsufficient, please recharge the watch, last statement received on {{date}}"
        },
        "THRESHOLD_MID": {
            "TITLE": "Correct {{lvl}}%",
            "SUBTITLE": "Mid Battery level, last statement received on {{date}}"
        },
        "THRESHOLD_HIGH": {
            "TITLE": "High {{lvl}}%",
            "SUBTITLE": "Battery level ok, last statement received on {{date}}"
        }
    },
    "SYSTEM_STATE": {
        "TITLE": "Service status",
        "OK": {
            "TITLE": "Service fully working",
            "SUBTITLE": "No issue detected"
        },
        "BAD": {
            "TITLE": "Service not working",
            "SUBTITLE": "Issue detected"
        }
    },
    "LANGUAGE_PREFERENCES": {
        "TITLE": "Language preference of",
        "LANGUAGE": "Language of",
        "DEFAULT_LANGUAGE_HELPED": "Alert service language of",
        "UPDATE_SUCCESS": "Modifications saved"
    },
    "EMAIL_CHECKER": {
        "ACCOUNT_ACTIVATED": "Account activated.",
        "CAN_SIGNIN": "You can now log in."
    },
    "LOGIN": {
        "SUBSCRIBE": "Subscribe",
        "FORM_TITLE": "Login",
        "PASSWORD_PLACEHOLDER": "Password",
        "FORGOT_PASSWORD_LINK": "Forgotten password?",
        "LOGIN_BUTTON": "Login",
        "OTP_PASSWORD": "MFA code",
        "OTP_ERROR": "The MFA code is incorrect",
        "OTP_MUST_BE_SUPPLIED": "Please fill the MFA code",
        "OTP_NO_AVAILABLE_CHANNEL": "Your account could not received OTP channel. Please, contact our support",
        "OTP_ALTERNATIVE_CHANNEL": "Receive the code via {{channel}}",
        "OTP_SENT": "A code has been sent via {{channel}}, it is valid for {{minutes}} minutes",
        "OTP_CHANNEL": {
            "push_notification": "mobile notification",
            "email": "email"
        },
        "PASSWORD_TOO_OLD": "Your password is outdated.",
        "RENEW_PIN_CODE_LINK": "Clic here to renew it",
        "LOGIN_FAILURE": "Incorrect username or password.",
        "LOGIN_BLOCKED": "Any connection attempt is blocked for {{arg}} minutes",
        "REMAINING_ATTEMPT": "Attention, you have {{arg}} remaining try before the connection is blocked",
        "REMAINING_ATTEMPTS": "Attention, you have {{arg}} remaining tries before the connection is blocked",
        "MISSING_VERIFICATION": "You must validate your account, by clicking here.",
        "NOT_REGISTERED": "No existing account",
        "ENTER_OTP": "Enter code",
        "ENTER_OTP_HINT": "Use a code generated by Authenticator",
        "ASK_OTP": "Receive code",
        "ASK_OTP_HINT": "Code will be send by mobile or email",
        "ASK_OTP_LINK_DISABLED": "Please, wait 1 minute between each send"
    },
    "REGISTRATION": {
        "FORM": {
            "CIVILITY": "The civility is mandatory",
            "LAST_NAME": "The last name is mandatory",
            "FIRST_NAME": "The first name is mandatory",
            "NAME": "The name is mandatory",
            "EMAIL": "The e-mail must be a valid address",
            "PASSWORD": "The pin is mandatory",
            "CONFIRM_PASSWORD": "Pins do not match",
            "PASSWORD_PATTERN": "The pin must contain 6 figures.",
            "PIN_TOO_SIMPLE": "Pin code is too simple.",
            "PHONE_NUMBER": "The phone number is mandatory",
            "PHONE_NUMBER_FORMAT": "This phone number is invalid",
            "ADDRESS": "The postal address is mandatory",
            "TIMEZONE": "The time zone is mandatory",
            "LANGUAGE": "The language is mandatory",
            "DELIVERY_ADDRESS": "Delivery address",
            "ADDRESS_RADIO": "The field 'Is this the delivery address?' is mandatory",
            "FIELD_MANDATORY": "The field '{{fieldName}}' is mandatory",
            "INVALID_CARD_NUMBER": "This card number is invalid",
            "INVALID_CODE_NUMBER": "This CVC is invalid",
            "INVALID_EXPIRY_DATE": "This expiry date is invalid"
        },
        "STEP": {
            "NETWORK_CHECK": {
                "TITLE": "Network check",
                "FIRST_QUESTION": "Is the user's home properly covered?",
                "UNKNOWN_ADDRESS": "Can't find your address? Try with the postal code or contact us on",
                "INFO": "Home coverage depends on its configuration (floor, construction standard, thick walls)",
                "TAX": "All prices listed are eligible for the 50% tax credit (French only)",
                "ACTION": "Check coverage",
                "OUTDOOR_TITLE": "Outdoors",
                "OUTDOOR_COVERAGE": {
                    "OK": "the network is sufficient outside for the proper functioning of the watch.",
                    "WEAK": "the network is limited for outdoor usage. Using the watch outdoors is not recommended as some alerts may not be transmitted.",
                    "KO": "the network in place does not allow the use of the watch outdoors."
                },
                "INDOOR_TITLE": "Indoors",
                "INDOOR_COVERAGE": {
                    "OK": "the network is sufficient indoors for the proper functioning of the watch.",
                    "WEAK": "the network is insufficient indoors for the proper functioning of the watch. The installation of a repeater at home is required. The repeater does not improve the network outdoors.",
                    "KO": "the existing network does not allow the watch to be used indoors. To ensure operation, the installation of an antenna at home is required. The antenna allows to cover the home and the garden if necessary. The installation of the antenna requires a wired internet connection and a power outlet. The antenna does not improve the network outdoors."
                },
                "CONTACT_CUSTOMER_SERVICE": "If in doubt, contact the customer service by chat or by telephone at {{phoneNumber}}",
                "TIPS": {
                    "repeater": "A repeater amplifies the signal; a minimal coverage is necessary, even weak.",
                    "antenna": "An antenna creates its own signal from an internet connection (3G or Ethernet), which allows the emission of alerts even without coverage."
                },
                "LINK_TITLE": "[fact sheet in French]",
                "LINK": {
                    "repeater": "https://hubs.ly/H0mzxjK0",
                    "antenna": "https://hubs.ly/H0mzxSf0"
                },
                "SELECT_OPTION": "I select my option",
                "SHIPPING_INFO": "Shipping fee of €{{price}}.",
                "OPTIONS": {
                    "renting": "Renting",
                    "purchase": "Purchase",
                    "none": "None",
                    "repeater": "Repeater",
                    "antenna": "Antenna",
                    "renting_price": "€{{price}}/month",
                    "purchase_price": "€{{price}}",
                    "renting_repeater": "I rent a repeater (€{{price}}/month)",
                    "purchase_repeater": "I buy a repeater (€{{price}})",
                    "renting_antenna": "I rent an antenna (€{{price}}/month)",
                    "purchase_antenna": "I buy an antenna (€{{price}})"
                }
            },
            "PERSONALIZE": {
                "TITLE": "Personalize",
                "FIRST_QUESTION": "Do you already have a Co-assist Alert Watch?",
                "WATCH_OWNER": "I already own the watch",
                "WATCH_NOT_OWNER": "I don't have a watch yet",
                "IDENTIFICATION_NUMBER_TITLE": "What is your watch's identification number?",
                "IDENTIFICATION_NUMBER": "Watch identification number",
                "IDENTIFICATION_NUMBER_HELPER": "The identification number is on the welcome mail",
                "INVALID_IDENTIFICATION_NUMBER": "The identification is incorrect",
                "SELECT_PROCESS": "Who should be contacted in the event of an alert?",
                "EMBEDDED": "My family and friends",
                "TELECARE": "A professional listening deck",
                "TELECARE_PRICE": "Supplement 10€ / month (5€ after tax credit)",
                "SELECT_ITEM": "I choose my accessory",
                "SELECT_DISPLAY": "What display do you want?",
                "WATCH_DISPLAY": "Watch display",
                "WATCH_NUMERIC": "Digital display",
                "WATCH_NUMERIC_DDMM": "Digital display with date",
                "WATCH_HANDS": "Analog display"
            },
            "ACCOUNT_CREATION": {
                "TITLE": "Account creation",
                "FIRST_QUESTION": "Are you the watch's user (the wearer)?",
                "WATCH_HELPED": "I'm the user",
                "WATCH_HELPER": "I'm not the user",
                "YOUR_ACCOUNT": "Your account",
                "USER_ACCOUNT": "User's account",
                "DELIVERY_ADDRESS": "Is this the delivery address?",
                "RECIPIENT_ADDRESS": "Recipient address",
                "RECIPIENT_FIRSTNAME": "Recipient firstname",
                "RECIPIENT_LASTNAME": "Recipient lastname",
                "AUTO_GENERATED": "Send me a random password",
                "PASSWORD": "Password",
                "CONFIRM_PASSWORD": "Password confirmation"
            },
            "PAYMENT": {
                "TITLE": "Validate the order",
                "SECURE_PAYMENT": "100% secure payment",
                "CART": "Summary",
                "ADDITIONAL_INFO": "Additional information (delivery details, etc.)",
                "CONFIRM_ORDER": "Confirm order",
                "TOTAL_AMOUNT": "Total amount",
                "FIRST_DEBIT": "First debit",
                "CB": {
                    "NAME": "Bank card"
                },
                "SEPA": {
                    "NAME": "SEPA bank transfer",
                    "IBAN": "IBAN number",
                    "IBAN_INVALID": "This IBAN number is invalid",
                    "FIRST_NAME": "Firstname of the owner",
                    "LAST_NAME": "Last name of the owner",
                    "ADDRESS": "Address of the owner",
                    "ADDRESS_INVALID": "Entered address is invalid"
                },
                "MAKE_PAYMENT_CHOICE": "Select your payment method",
                "CHECKBOX": {
                    "GENERAL_CONDITIONS": "I expressly acknowledge having read and accept without reservation the Terms and Conditions of CO-ASSIST SERVICES",
                    "DEBIT": "I accept the automatic collection of the costs mentioned above.",
                    "CONSENT": "I agree that my information will be used by CO-ASSIST SERVICES throughout the duration of the contract and I certify to have received the consent of the persons mentioned in this contract.",
                    "TAX_CREDIT": "I declare that the CO-ASSIST SERVICES solution will be used exclusively for the home support of an elderly person or person with a disability.",
                    "TAX_CREDIT_NOTE": "This last condition is necessary to benefit from the tax credit related to people care. If this is not your case, ",
                    "CONDITIONS_MANDATORY": "The validation of the above conditions is mandatory",
                    "CONTACT": "contact us"
                },
                "PERSONAL_DATA": "Co-assist collects the personal data of this form in order to manage your contract. In application of the law n ° 78-17 of January 6th, 1978, modified on June 20th 2018 and of the European regulation 2016/679 of April 27th, 2016, you have the rights to opposition, access, rectification, erasure and portability of data concerning you, as well as limitation of the purposes. We keep your data along all the duration of your contract. For more information, see our Privacy Policy (French only). To exercise these rights, contact us at the following address:",
                "ALREADY_OWN_WATCH": {
                    "TITLE": "Do you want to enter your payment information now?",
                    "DIALOG": {
                        "TITLE": "Account creation confirmation",
                        "CONTENT": "You are about to validate the creation of your account without specifying your payment information, you can enter this information later."
                    }
                },
                "IS_ACQUERING_WATCH": {
                    "TITLE": "Which price option do you want?",
                    "NOT_METROPOLITAN": "If you are not a metropolitan France citizen, please contact us to know our offers."
                },
                "liberty": {
                    "TITLE": "Freedom formula",
                    "SUBTITLE": "Rent the watch with its alert service for more flexibility (FOR FRENCH METROPOLITAN NUMBER ONLY)",
                    "PRICING": "44,99€/month"
                },
                "economy": {
                    "TITLE": "Savings formula",
                    "SUBTITLE": "Buy the watch for saving use (FOR FRENCH NUMBER ONLY)",
                    "PRICING": "269,99€"
                },
                "saved": {
                    "TITLE": "Save it",
                    "SUBTITLE": "I will be debited automatically in 6 months",
                    "PRICING": "0,01€"
                },
                "none": {
                    "TITLE": "Later",
                    "SUBTITLE": "I'll enter my payment information later.",
                    "PRICING": "0€"
                },
                "DESCRIPTION": {
                    "FEE": "79€ for setting up the watch, training in its use and shipping",
                    "ECONOMY_CREDIT_TAX": "134.99€ after tax credit (50%) in France",
                    "LIBERTY_CREDIT_TAX": "22.49€ after tax credit (50%) in France",
                    "WATCH_RENT": "Rental watch (uncollected deposit of 240€ TTC)",
                    "NO_ENGAGEMENT": "No commitment",
                    "ECONOMY_NO_ENGAGEMENT": "No commitment and two weeks to test the solution and send it back if it is not suitable",
                    "ALL_FUNCTIONNALITIES": "All available features",
                    "ECONOMY_MONTHLY": "Subscription of 29.99€ / month (first month included) i.e. 14.99€ after tax credit (50%)",
                    "ONE_MONTH": "One month subscription included then 29,99€/month",
                    "SIX_MONTH": "Six months subscription included then 15€/month",
                    "CONTINUITY": "No service interruption after 6 months",
                    "TAX_CREDIT": "50% tax credit in France",
                    "RENTING": "Montre en location",
                    "TWO_WEEKS_TO_TEST": "Two weeks to test the solution and send it back if it doesn't work..."
                },
                "DISCOUNT": {
                    "LABEL": "Promotional code"
                },
                "DIALOG_RECOVER_DATA": {
                    "TITLE": "Do you want to recover your old form?",
                    "MESSAGE": "Your old form has been saved, would you like to resume where you left off?"
                },
                "DIALOG_PAYMENT": {
                    "SUCCESS_PAYMENT": "Congratulations, your payment has been registered",
                    "SUCCESS": "Congratulations, you can log in",
                    "3D_SECURE": "Your payment must be verified, you will be redirected to your bank",
                    "REDIRECT_PAYMENT_PAGE": "Return to payment page",
                    "CLOSE": "Close",
                    "ERROR": {
                        "TITLE": "An error occured",
                        "MESSAGE": "You have not been charged, you can try to renew",
                        "INVALID_PAYMENT_DATA": "Invalid payment data"
                    }
                },
                "RESULT": {
                    "SUCCESS": "Your transaction has been validated",
                    "FAILURE": "Your transaction has not been validated"
                },
                "MENSUAL_FEES": "Monthly service subscription starting on {{date}}",
                "MENSUAL_DEBIT": "{{currency}}{{price}} a month",
                "PRODUCT": "Product",
                "FEE": "Watch setup, training and shipping",
                "WATCH": "Watch",
                "REPEATER": "Repeater",
                "ANTENNA": "Antenna",
                "DELIVERY": "Delivery fee",
                "SUB_TOTAL": "Sub-total",
                "TOTAL": "Total to pay",
                "RENTING": "Monthly fee",
                "SERVICETELECARE": "Monthly subscription to the remote assistance service",
                "SUBSCRIPTION": {
                    "MONTHLY": "Monthly fee watch + service",
                    "economy": "“Economy option”",
                    "liberty": "“Liberty option”",
                    "saved": "",
                    "NONE": ""
                }
            }
        },
        "WATCH_DIALOG": {
            "TITLE": "Bracelet size",
            "SUBTITLE": "Receive your bracelet in the proper size by precising below your wrist size. If you do not know your size, choose the largest so you can cut the bracelet to the proper size at home.",
            "WATCHBAND_SIZE": "Your wrist size en cm:"
        },
        "TITLE": "Subscription",
        "CUSTOMER_SERVICE": "Customer service:",
        "CUSTOMER_SERVICE_NUMBER": "+33 (0) 2 78 34 04 51",
        "GET_BOOKLET": "Receive the brochure",
        "LEGAL_INFO": "Legal Information - General Terms and Conditions (French)",
        "PAYMENT": {
            "TITLE": "Payment",
            "SAVE_PAYMENT_INFOS": "Save my payment information",
            "CARD_NUMBER": "Card number",
            "CARD_OWNER": "Card holder",
            "EXPIRATION_MONTH": "Month",
            "EXPIRATION_YEAR": "Year",
            "CODE": "CVV",
            "INFO_CODE": "A visual cryptogram is a unique series of three numbers, printed on most credit cards. You will find on the back of Visa and MasterCard."
        },
        "CARRIER": {
            "EMAIL": "Email (either final user's or relative's)"
        },
        "ERROR": {
            "CIVILITY": "Please fill the gender",
            "EMAIL": "Email field not valid, please try again",
            "TEL": "Phone number not valid, please try again"
        }
    },
    "CONTENT": {
        "NAVBAR": {
            "SELECT_USER": "User...",
            "DASHBOARD": "Dashboard",
            "ALERTS_CONF": "Alert settings",
            "ACTIONS": "Helpers and processes",
            "RECORDS": "Records",
            "ACTIVITY": "Activity",
            "TEMPERATURE": "Temperature",
            "DOOR": "Door",
            "PROFILE": "User profile",
            "CONTRACT": "User contract",
            "ADMINISTRATION": "Administration",
            "DASHBOARD_B2B": "General dashboard",
            "GROUP_ASSOCIATIONS": "User/equipment pairing",
            "ALERT_PROCESS_MANAGEMENT": "Default alert settings",
            "DEVICE_LOCATION": "Positioning",
            "MY_PROFILE": "My profile",
            "MY_CONTRACT": "My contract"
        },
        "MORE": "More",
        "LANGUAGE": "Language",
        "LAYOUT": "Modify layout",
        "APPLICATION": "Application",
        "SETTINGS": "Settings",
        "LOGOUT": "Log out",
        "HELP": "Support",
        "FAQ": "Help service",
        "RELEASE_NOTE": "New releases",
        "STATUS_PAGE": "Status of services"
    },
    "CONTRACT": {
        "MY_CONTRACT": {
            "TITLE": "My contract",
            "ASK_SUBSCRIPTION": "My subscription request",
            "CGS": "Terms of Service",
            "UNSUBSCRIBE": "Unsubscribe",
            "TOAST": {
                "ERROR": "The file doesn't exist"
            }
        },
        "PAYMENT": {
            "TITLE": "Payment method",
            "SUBSCRIPTION": "My subscription:",
            "OPTIONS": "My options(s):",
            "SUBSCRIPTION_SERVICE_START_DATE": "starting {{date}}",
            "SUBSCRIPTION_STATE": "Subscription state:",
            "SUBSCRIPTION_INACTIVE": "waiting for validation",
            "SUBSCRIPTION_DATE": "Subscription date:",
            "NEXT_PAYMENT_DATE": "Next payment:",
            "NEXT_PAYMENT_DETAIL": "{{currency}}{{price}} on {{date}}",
            "NOT_AN_ONLINE_SUBSCRIPTION": "You have not subscribed online",
            "EDIT_PAYMENT_METHOD": "Change my payment method",
            "VALIDATE_PAYMENT_METHOD": "Validate my payment method"
        },
        "BILLS": {
            "TITLE": "Invoices",
            "TYPE": {
                "invoice": "Invoice of {{total}} emitted on {{createdAt}}",
                "creditNote": "Credit note of {{total}} emitted on {{createdAt}}"
            },
            "DOWNLOAD_BILL": "Download invoice",
            "ASK_BILL": "Ask for invoice in this period",
            "NO_INVOICES": "No available invoices in this period",
            "GET_MAIL_INVOICE": "I would like to be notified on each new invoice",
            "BILLING_YEAR": "Billing year",
            "TOAST": {
                "ERROR": "Failed to retrieve invoice"
            }
        },
        "TAX": {
            "TITLE": "My tax certificates",
            "DOWNLOAD_TAX": "Ask for tax certificate",
            "SELECT_YEAR": "Select a year",
            "TOAST": {
                "ERROR": "There is no certificate for the selected year"
            }
        },
        "UNSUBSCRIBE": {
            "TITLE": "Unsubscribe {{helpedName}}",
            "TEXT": {
                "SORRY": "We are sorry that you are terminating your contract with Co-assist.",
                "DEACTIVATION": "As stipulated in our terms and conditions, after termination the equipment will be disabled and you will no longer be able to use it.",
                "RETURN_ADDRESS": "If you didn't purchased it, you have 30 days to send back the watch and its complete charger to <strong>CO-ASSIST, 77 rue Michelet, 76600 Le Havre, France</strong>, or you will be charged €190. Co-assist is committed to recycling its products."
            },
            "WHY": "Why do you want to terminate your contract with Co-assist?*",
            "IMPROVE": "Would you like to send us a comment to improve our service?",
            "RAISON_TWO": "Death",
            "RAISON_ONE": "Nursing home departure",
            "RAISON_THREE": "House move",
            "RAISON_FOUR": "Dissatisfied with the fall detection",
            "RAISON_FIVE": "Dissatisfied with the zone exit detection",
            "RAISON_SIX": "Unsufficient network coverage",
            "RAISON_SEVEN": "Other: please clarify in comments",
            "TOAST": {
                "ERROR": "Failed to unsubscribe",
                "SUCCESS": "Notification sent"
            }
        }
    },
    "POSITION_TRACKING": {
        "TITLE": "Location tracking",
        "CAUTION_TRACKING_DEACTIVATE": "Caution: in order to work, location tracking must be enabled",
        "ACTIVATE": "Activate"
    },
    "CSV_HEADER": {
        "FILE_NAME": "Alert history of",
        "ALERT": "Alert",
        "USERID": "UserID",
        "DEVICE_TYPE": "Equipment type",
        "NAME": "Name",
        "ALERT_ID": "AlertID",
        "MODULEID": "moduleID",
        "ALERT_TYPE": "Alert Type",
        "ALERT_DATE": "Start date",
        "ALERT_TIME": "Start time",
        "ALERT_HANDLE_TIME": "Duration before handover",
        "ALERT_HANDLE_TIME_IN_SEC": "Duration before pick-up [sec]",
        "ALERT_HANDLE_DATE": "Pick-up time",
        "ALERT_HANDLER": "Handled",
        "ALERT_INTERRUPT_TIME": "Duration before interruption",
        "ALERT_INTERRUPT_TIME_IN_SEC": "Duration before interruption [sec]",
        "ALERT_INTERRUPT_DATE": "Interrupt time",
        "ALERT_ACQUIT_TIME": "Duration before acknowledgement",
        "ALERT_ACQUIT_TIME_IN_SEC": "Duration before acknowledgement [sec]",
        "ALERT_ACQUIT_DATE": "Acknowledgement time",
        "ALERT_ACQUITTED_BY": "Acquittement method",
        "QUALIFICATION": "Event qualification",
        "COMMENT": "Comments"
    },
    "DISCOUNT_CODE": {
        "PROMOTIONAL_CODE": "Promotional code",
        "VALIDATE_CODE": "Apply code",
        "TOAST": {
            "VALID_CODE": "The entered code has been applied",
            "INVALID_CODE": "The entered code is invalid"
        }
    },
    "USER_AUTOCOMPLETION": {
        "ERROR": "You must enter a valid user"
    },
    "SUBSCRIPTION": {
        "saved": "Service",
        "none": "None",
        "none-unsubscribe": "Awaiting return for termination",
        "none-waiting": "Awaiting validation for subscription",
        "none-partner": "Partner contract",
        "liberty": "Liberty",
        "liberty-repeater": "Liberty with a repeater rent",
        "liberty-antenna": "Liberty with an antenna rent",
        "liberty-reunion": "Liberty (Réunion island)",
        "economy": "Economy",
        "economy-repeater": "Economy with a repeater rent",
        "economy-antenna": "Economy with an antenna rent"
    },
    "OPTION": {
        "RENTANTENNA": "Antenna Renting",
        "RENTREPEATER": "Repeater Renting",
        "RENTREPEATER2": "Repeater Renting",
        "SERVICETELECARE": "Telecare Service"
    },
    "USER_OVERVIEW": {
        "TITLE": "Administration",
        "CURRENTLY_LOGGED_IN_AS": "Currently logged in as",
        "SEARCH_BUTTON": "Search",
        "ACTIONS": {
            "LOG_OUT": "Log out",
            "OPEN_BACK_OFFICE": "Open back office",
            "LOGOUT_ACTUAL_USER": "Logout actual user"
        },
        "ERROR": {
            "NO_USER": "User does not exist"
        }
    },
    "PRIVACY": {
        "POSITION": {
            "TITLE": "Access to Location Log",
            "DESCRIPTION": "According to the General Data Protection Regulation (GDPR), access to location data must be justified by a call for intervention from the user or by an emergency situation requiring to know the user's whereabouts",
            "CONFIRMATION": "Do you confirm requesting access under those terms?"
        },
        "GDPR": {
            "MANAGE": "Manage my personal data,",
            "TITLE": "Data privacy",
            "DESCRIPTION": "I wish to ",
            "CHOICE": "{{action}}",
            "CHOICES": {
                "read": "exercise my right to consult",
                "update": "exercise my right to rectify",
                "delete": "exercise my right to delete",
                "violation": "declare a data violation"
            },
            "COMMENTARY": "Would you like to leave us a comment?"
        }
    },
    "ACTIVITY": {
        "TITLE": "Activity tracking of the wearer of the watch",
        "SHORT_TITLE": "Activity tracking",
        "SERIE": "Activity value",
        "AVERAGE": {
            "LABEL": "Average",
            "LEGEND": "Period's average activity"
        },
        "RECOMMENDED": {
            "LABEL": "Recommended",
            "LEGEND": "Minimum recommended activity by Co-asssist"
        },
        "WHO": {
            "LINK": "World Health Organization recommendations for physical activity",
            "CONTENT": "<strong>WHO recommendations</strong><br><br><I>Older adults should do at least 150 minutes of moderate-intensity physical activity throughout the week.<br>Activity should be performed in bouts of at least 10 minutes duration.</I><br><br><a href=\"https://www.who.int/dietphysicalactivity/physical-activity-recommendations-65years.pdf\">More information</a>"
        },
        "MISSING_DATA": "Not enough data available",
        "NO_DATA": "No data"
    },
    "TEMPERATURE": {
        "TITLE": "Ambient temperature",
        "ALERT_THRESHOLD": "Alert threshold",
        "CHECKING": "Temperature checking",
        "SHORT_TITLE": "Ambient temperature",
        "MIN": {
            "LABEL": "19°C",
            "LEGEND": "Minimum recommended temperature"
        },
        "MAX": {
            "LABEL": "32°C",
            "LEGEND": "Maximum recommended temperature"
        },
        "SERIE": "Temperature",
        "MISSING_DATA": "Not enough data available",
        "NO_DATA": "No data",
        "WHO": {
            "LINK": "World Health Organization recommendation",
            "CONTENT": "<strong>WHO recommendations</strong><br><br><I>For the elderly, the ideal heating temperature is more likely to be around 24°C for living areas during the day, and 19°C at night.</I><br><br><I>During hot spells, the room temperature should not exceed 32°C during the day and 24°C at night.</I><a href=\"https://www.who.int/news-room/fact-sheets/detail/climate-change-heat-and-health\">More information</a>"
        },
        "CONFIG_THRESHOLD": {
            "PREFIX": "Trigger the alarm if the value detected by the sensor is ",
            "OPERATOR": "Operator",
            "TEMPERATURE": "Temperature (°C)"
        }
    },
    "DOOR": {
        "TITLE": "Door sensors status tracking",
        "STATES": {
            "open": "Opened",
            "close": "Closed"
        },
        "SELECTION_TITLE": "Door sensor",
        "NO_DATA": "No data"
    },
    "RANGE": {
        "ACQUIRED": "Acquisition period",
        "FROM": "From",
        "TO": "To",
        "SELECT_ONE_HOUR": "Last hour",
        "SELECT_SIX_HOURS": "Last 6 hours",
        "SELECT_ONE_DAY": "Today",
        "SELECT_TWO_DAY": "2 days",
        "SELECT_ONE_WEEK": "1 week",
        "SELECT_TWO_WEEK": "2 weeks",
        "SELECT_ONE_MONTH": "1 month",
        "SELECT_SIX_MONTH": "6 months",
        "BETWEEN_TWO_DATES": "Between two dates",
        "CURRENT_YEAR": "Current year"
    },
    "SCHEDULE": {
        "PROFILE_NAME": "Name",
        "PROFILE_PLACEHOLDER": "Morning, evening, week-end, ...",
        "PROFILE_NOTIF": "Default notification set",
        "MODIFY_DAY": "Modify {{day}}'s planning",
        "COPY_DAY": "Duplicate planning",
        "COPY_BODY": "Select the days you wish to duplicate the {{day}} configuration",
        "TIME_RANGE": "{{from}} to {{to}} : Configuration {{name}}",
        "CONFIGURED_TIME_RANGE": "Configured time ranges",
        "SELECT_CONFIG": "Notification set",
        "SELECT_DAYS": "Days",
        "SELECT_TIME_RANGE": "Time range",
        "WHOLE_DAY": "Whole day",
        "COPY": "Duplicate",
        "RESET": "Delete",
        "RESET_ALL": "Delete all",
        "SIMPLIFIED_SCHEDULING": "Simplified scheduling",
        "FREE_SLOT": "Time slot without notification",
        "SCHEDULE_ACTIVATE": "Planning activated",
        "SCHEDULE_EMPTY": "No time range selected",
        "INFOS": "<p>Notification sets scheduling allows you to assign a notification set to a specific time slot.</p><div class='alert alert-success'>Example : I own a notification set named &laquo;Morning&raquo; which corresponds to sending an email to<br/> &laquo;example@co-assist.fr&raquo;.<br/>I am able to assign this notification set from Monday to Friday from 6 AM to 12 PM in order to receive an email in case of an alert in this time slot.</div><p>It is possible to schedule several notification sets in a day and duplicate it (copy and paste) to other days of the week.</p>"
    },
    "ADDRESS_AUTOCOMPLETE": {
        "ERROR_SELECTION": "Please choose an address in the proposed list"
    },
    "MAT_PAGINATOR": {
        "FIRST_PAGE": "First page",
        "ITEMS_PER_PAGE": "Users per page",
        "LAST_PAGE": "Lasr page",
        "NEXT_PAGE": "Next page",
        "PREVIOUS_PAGE": "Last page",
        "OF": "of"
    },
    "DEVICES": {
        "SETTINGS": {
            "button_long_pressure": "Button press duration",
            "realTimeTracker": "Location tracking",
            "time_mode": "Watch display",
            "utc_time_zone": "Time zone"
        }
    },
    "ALERT_DETAILS": {
        "TITLE": "Description of the alert of {{name}}",
        "DETAILS": "Alert details",
        "DEVICE_TYPE": "Equipment type",
        "FLOW": "Alert flow",
        "ID": "Alert ID",
        "USERID": "User",
        "TYPE": "Alert type",
        "STATUS": "Alert status",
        "START": "Start of the alert",
        "DATE": "Date of alert",
        "START_TIME": "Start time",
        "END_TIME": "End time",
        "ACK_TIME": "Acknowledgement time",
        "LAST_UPDATE": "Last update",
        "QUALIFICATION": "Event qualification",
        "COMMENT": "Comments",
        "HANDLE": "Handle",
        "REQUEST_BY": "Request by {{name}}",
        "ACKNOWLEDGE": "Acknowledge"
    },
    "ALERT_STATUS": {
        "ACQUITTED_BY": {
            "IN_SITU": "Acquitted In Situ",
            "APP": "Acquitted with app",
            "CALL": "Acquitted with phone",
            "BY": "by {{helperDisplayName}}"
        },
        "acquitted": "Acquitted",
        "ACQUITTED_BY_IN_SITU": "Acquitted In Situ",
        "ACQUITTED_BY_APP": "Acquitted by app",
        "ACQUITTED_BY_CALL": "Acquitted by phone",
        "close": "Closed",
        "expired": "Expired",
        "handle": "Handled  by {{name}}",
        "interrupted": "Interrupted",
        "start": "Launched",
        "notifying": "Notification",
        "solved": "Solved",
        "trying_new_notification": "Notification",
        "LOCATION": "Alert location: next to “{{place}}“",
        "LOCATION_SINCE": "since {{time}}",
        "waiting_for_response": "Waiting for response",
        "waiting_for_handling": "Waiting for handling",
        "waiting_for_acquitting": "Waiting for acknowledgment.<br/> Alert handled by <em>{{name}}</em>.",
        "waiting_for_closing": "Waiting for closing"
    },
    "ALERT_QUALIFICATION": {
        "TITLE": "Distribution of alerts by qualification",
        "NO_ALERT": "No alert",
        "ALERT_NUMBER": "Alerts number",
        "null": {
            "TITLE": "Not qualified",
            "HELPER": "The event has not been qualified"
        },
        "undefined": {
            "TITLE": "Not qualified",
            "HELPER": "The event has not been qualified"
        },
        "alert": {
            "TITLE": "Alert",
            "HELPER": "Alert related to a distress situation or technical alert of a device (low battery, device not working ...)"
        },
        "test": {
            "TITLE": "Test",
            "HELPER": "Alert generated to test a device or notification"
        },
        "inappropriate": {
            "TITLE": "Spurious alert",
            "HELPER": "Inappropriate alert trigger or false positive"
        },
        "courtesy": {
            "TITLE": "Courtesy call",
            "HELPER": "Alert for a reason other than distress, e.g. need for assistance with a task of daily living"
        },
        "duplicate": {
            "TITLE": "Duplicate",
            "HELPER": "Alert triggered when an alert is already in progress"
        }
    },
    "ALERT_ACTION": {
        "HANDLE": "Taking charge",
        "ACKNOWLEDGE": "Acknowledge",
        "HANDLE_ALL": "Take charge user alerts",
        "ACKNOWLEDGE_ALL": "Acknowledge user alerts",
        "ACKNOWLEDGEMENT_IN_SITU": "In situ acknowledgement",
        "ACKNOWLEDGEMENT_IN_SITU_EXPLANATION": "The alert must be acknowledged on one of the user's devices",
        "QUALIFY": "Qualify the alert"
    },
    "CATALOG": {
        "TITLE": "Catalog",
        "STOCK": "Stock : {{stock}}",
        "OUT_STOCK": "Out of stock",
        "REPLENISHMENT": "Replenishment",
        "END_OF_SERIES": "End of series",
        "FILTER_TITLE": "Filter by device",
        "FILTER_VALUE": " and {{counter}} other(s) device(s)",
        "FILTER_ALL": "All devices",
        "NO_ITEMS": "No accessory available for this device",
        "STAR_PRODUCT": "Star product, quick replenishment"
    },
    "BATTERY_TO_BE_CHARGED": {
        "MODULE_ID": "moduleID",
        "DISPLAY_NAME": "User",
        "BATTERY_LEVEL": "Battery level",
        "NO_LOW_BATTERY": "The battery level of watches is sufficient"
    },
    "CAW_SETTINGS": {
        "UNSYNCHRONIZED": "Unsynchronized settings",
        "clock_mode_analogDigit": "Affichage de l'heure",
        "real_time_tracking": "Suivi de position",
        "utc_time_zone": "Fuseau horaire",
        "button_long_pressure": "Durée d'appui du bouton",
        "fall": "Détection de chute",
        "button": "Appui du bouton"
    },
    "DIALOG_UPLOAD_FILE": {
        "TITLE": "Update profile picture",
        "BUTTON": "Load a picture",
        "INVALID_IMAGE_SIZE": "Image size too large, maximum size {{maxImageSize}} kB",
        "INVALID_IMAGE_TYPE": "Invalid image format, formats accepted : {{acceptedType}}",
        "DIALOG_INFO": {
            "TITLE": "Update profile picture",
            "TEXT": "This option allows you to change your profile picture.<br><br><b>formats accepted {{acceptedType}}<br>maximum file size {{maxImageSize}} Ko</b>"
        }
    },
    "SELECT_CUSTOM": {
        "ALL_STATES": "All states"
    },
    "HUB": {
        "CHOOSE_MODE": "Which service would you use ?",
        "TELEMETRY": "Telemetry service",
        "ALERT": "Alerts service",
        "SWITCH": "Switch to '{{to}}'"
    },
    "TELEMETRY": {
        "PDF": "Generate PDF",
        "EDIT_FEES": "Edit fees",
        "EXPORT_CONSUMPTION_DATA": "Export consumption data from {{from}} to {{to}}",
        "SHOW_CONSUMPTION": "Show consumption",
        "ACCOMODATION_SELECTION": "Select accomodation",
        "ENTRY_DATE": "Entry tenant date",
        "EXPORT_DATE": "Reporting date",
        "DECLARE_NEW_TENANT": "Declaring the arrival of a new tenant",
        "EXPORT_REPORT": "Generate information report",
        "EDIT_REPORT": "Information report",
        "CONSUMPTION": "Consumption",
        "CONSUMPTION_PRICE": "Enter a rebilling price per 1m³",
        "EXPORT_ALL": "Export consumption data for all homes",
        "AGGREGATED_VIEW": "Aggregated view",
        "ACCOMODATION": "Accomadation",
        "WATER_METER": "Meters",
        "DOWNLOAD_DATA": "Download report | CSV",
        "SET_DATES": "Set dates",
        "STARTING_DATE": "Start date",
        "ENDING_DATE": "End date",
        "INVALID_STARTING_DATE": "Date de début invalide",
        "INVALID_ENDING_DATE": "Date de fin invalide",
        "COLD_WATER_METER": "Cold water meter",
        "HOT_WATER_METER": "Hot water meter",
        "GLOBAL_CONSUMPTION": "Global facility consumption",
        "COLD_WATER_GLOBAL_CONSUMPTION": "Global cold water facility consumption",
        "HOT_WATER_GLOBAL_CONSUMPTION": "Global hot water facility consumption",
        "HOT_WATER_CONSUMPTION_FEE": "Hot water rate per m3",
        "COLD_WATER_CONSUMPTION_FEE": "Cold water rate per m3",
        "SUBSCRIPTION_FEE": "Water rate per m3",
        "SELECT_YEAR": "Select a year",
        "FEES_NOT_EDITABLE": "Les tarifs ne sont modifiables que sur l'année courante"
    },
    "CUSTOM_RANGE_PICKER": {
        "PRE_DEFINED_RANGE": {
            "LAST_WEEK": "Last week",
            "LAST_MONTH": "Last month",
            "MONTH_TO_DATE": "Last month to date",
            "YEAR_TO_DATE": "Last year to date"
        },
        "SPECIFIC_RANGE": {
            "CUSTOM_RANGE": "Between two dates",
            "SINCE_ENTRY": "Since date of arrival",
            "SINCE_LAST_FLAG": "Since last due date"
        }
    },
    "QUICK_LOGIN": {
        "TITLE": "Quick connection to the Android application",
        "VALIDITY": "The QRCode is valid until {{date}}",
        "EXPLANATION": "Make sure the Co-assist app is installed, scan the QRCode with your Android smartphone's camera, then follow the link that appears to connect instantly."
    },
    "TIME_AGO": {
        "FEW_SECONDS": "Few seconds ago",
        "A_MINUTE": "A minute ago",
        "N_MINUTE": "{{minutes}} minutes ago",
        "MORE_THAN_HOUR": "Over an hour ago"
    },
    "LOCALIZATION": {
        "MODAL": {
            "TITLE": "Localization",
            "INFO": "Two display modes are available: map mode and table mode."
        },
        "USER": "User",
        "LAST_UPDATE": "Last update",
        "POSITION": "Position",
        "MAP_MODE": "Switch to map mode",
        "TABLE_MODE": "Switch to table mode",
        "CONNECTED": "Connected to the mesh network",
        "DISCONNECTED": "Disconnected from the mesh network",
        "ZONE_NAME": "Zone name",
        "ZONE_COLOR": "Zone color",
        "ADD_ZONE": "Name of the zone to create",
        "LOCALIZE_BEACON": "Place a beacon",
        "LOCALIZE_REPORT": "Place a report",
        "PLEASE_LOCALIZE_MARKER": "Please position the reference points",
        "ZONE": "Zone: {{zone}}",
        "BEACON": "Beacon: {{beacon}}",
        "EDIT": {
            "DISPLAY_HIDE": "Show/Hide",
            "ZONES": "Zones",
            "BEACONS": "Beacons",
            "MARKERS": "Reference GPS positions",
            "ADD_ZONE": "Add a zone",
            "RENAME_ZONE": "Rename the zone",
            "CHANGE_ZONE_COLOR": "Change zone color",
            "EDIT_ZONE": "Edit zone boundary",
            "DELETE_ZONE": "Delete zone",
            "ADD_BEACON_LOCATION": "Place a beacon",
            "DELETE_BEACON_LOCATION": "Remove beacon location",
            "GOOGLE_MAP_LINK": "Access Google Maps",
            "ADD_A_MARKER": "Add a reference position",
            "ADD_MARKER": "Reference GPS position",
            "EDIT_MARKER": "Edit reference GPS position {{name}}",
            "DELETE_MARKER": "Delete reference GPS position {{name}}",
            "DELETE_VERTEX": "Delete this vertex",
            "DISPLAY_MARKER": "Show GPS position on Google Maps",
            "HELPER_GMAP_INPUT": "Paste the value copied from Google Maps",
            "HELPER_HINT": "Click on the desired spot, right-click the pin, then click the GPS coordinates to copy",
            "LAT": "Latitude",
            "LNG": "Longitude"
        }
    },
    "LAYOUT": {
        "BREAKPOINT": "For screens smaller than 992px, blocks take the full width",
        "MODIFY": "Modify layout",
        "VISIBILITY": "Visibility",
        "WIDTH": "Block width",
        "SHOW_SIDENAV": "Sidebar visibility",
        "RESET": "Reset block",
        "RESET_ALL": "Reset page",
        "DIALOG_CONFIRM": {
            "TITLE": "Confirmation",
            "BODY": "Do you want to reset the page layout?"
        }
    }
}